export const eng = {
  "CONTINUE": "Continue",
  "SECURE": "Secure",
  "PRIVATE": "Private",
  "LOADING_DATA": "Loading data",
  "IS_REQUIRED": "is required",
  "SEARCH": "Search",
  "Search": "Search",
  "SUBMIT": "Submit",
  "OK": "OK",
  "ACTIVE": "Active",
  "INACTIVE": "Inactive",
  "STARTER": "STARTER",
  "PLUS": "PLUS",
  "SCALE": "SCALE",
  "PRODUCTION": "PRODUCTION",
  "SANDBOX": "SANDBOX",
  "No options available": "No options available",
  "Resource not found.": "Resource not found.",
  "Internal error.": "Internal error.",
  "Invalid credentials.": "Invalid credentials.",
  "General": "General",
  "Institutions": "Institutions",
  "Accounts": "Accounts",
  "Cash position": "Cash position",
  "Transactions": "Transactions",
  "Transaction": "Transaction",
  "Developers": "Developers",
  "API Activity": "API Activity",
  "API Keys": "API Keys",
  "API Logs": "API Logs",
  "Webhooks": "Webhooks",
  "Relevant Links": "Shortcuts",
  "Live demo": "Live demo",
  "Widget": "Widget",
  "Guides and docs": "Guides and docs",
  "My profile": "My profile",
  "Company": "Company",
  "Change environment": "Change environment",
  "Your financial ecosystem through a single API.":
    "Your financial ecosystem through a single API.",
  "Welcome": "Welcome!",
  "back!": "back!",
  "Business Email": "Business Email",
  "Company domain": "Company domain",
  "Password": "Password",
  "Login": "Login",
  "Login to an external account": "Login to an external account",
  "You have an external account enabled":
    "You have an external account enabled",
  "You have no an external account enabled":
    "You have no an external account enabled",
  "Or": "Or",
  "Forgot your password?": "Forgot your password?",
  "Don't have an account?": "Don't have an account?",
  "Sign up": "Sign up",
  "It's ok, it happens sometimes. Please enter your email address and we'll send you a link to choose a new one.":
    "It's ok, it happens sometimes. Please enter your email address and we'll send you a link to choose a new one.",
  "Send me a reset link": "Send me a reset link",
  "Enter Verification Code": "Enter Verification Code",
  "Verification": "Verification",
  "Enter the verification code that has been sent to {{email}}":
    "Enter the verification code that has been sent to <strong>{{email}}</strong>",
  "The code sent is valid for 60 minutes.":
    "This code is valid for 60 minutes. Some Outlook users may experience delays in receiving the confirmation email. Please check your SPAM inbox.",
  "Don't receive the Code?": "Don't receive the Code?",
  "Verify Code": "Verify Code",
  "Verify Email": "Verify Email",
  "Account successfully verified!": "Account successfully verified!",
  "Verification code resended!": "Verification code resended!",
  "Resend Code": "Resend Code",
  "Resend email": "Resend email",
  "The password must contain at least {{count}} lowercase alphabetical characters.":
    "The password must contain at least {{count}} lowercase alphabetical characters.",
  "The password must contain at least {{count}} uppercase alphabetical characters.":
    "The password must contain at least {{count}} uppercase alphabetical characters.",
  "The password must contain at least {{count}} numeric characters.":
    "The password must contain at least {{count}} numeric characters.",
  "The password must contain at least {{count}} special characters.":
    "The password must contain at least {{count}} special characters.",
  "The password must be {{count}} characters or longer.":
    "The password must be {{count}} characters or longer.",
  "The password has expired and needs to be updated.":
    "The password has expired and needs to be updated.",
  "Please make sure your passwords match.":
    "Please make sure your passwords match.",
  "URL must start with https://": "URL must start with https://",
  "C-Level": "C-Level",
  "Finance": "Finance",
  "FINANCE": "Finance",
  "VIEW_FINANCE": "Finance",
  "OPERATOR": "Operator",
  "Operations": "Operations",
  "Product": "Product",
  "TI": "Developer",
  "Small business": "Small business",
  "Medium business": "Medium business",
  "Large enterprise": "Large enterprise",
  "Financial institution": "Financial institution",
  "Public sector": "Public sector",
  "Companies": "Companies",
  "Individuals": "Individuals",
  "Both": "Both",
  "Bank / Neobank": "Bank / Neobank",
  "Contability": "Contability",
  "Financial management": "Financial management",
  "Identity verification": "KYC",
  "Insurance": "Insurance",
  "Investment": "Investment",
  "Lending": "Credit",
  "Onboarding": "Onboarding",
  "Payments": "Payments",
  "Investment Movements": "Investment movements",
  "Payment receipt": "Payment receipt",
  "Payments receipt": "Payment receipt",
  "Payments Receipts successfully requested!":
    "Payments Receipts successfully requested!",
  "Payments receipts": "Payments receipts",
  "Request Payment Receipt": "Request Payment Receipt",
  "Payment Receipt successfully download!":
    "Payment Receipt successfully download!",
  "View Requested Payment Receipts list": "View list",
  "{{count}} Requested Payment Receipts": "{{count}} Payment Receipts",
  "Next request": "Next request",
  "Requested Payment Receipts": "Requested Payment Receipts",
  "downloadableSince": "downloadableSince",
  "Requested at": "Requested at",
  "Bulk actions": "Bulk actions",
  "Unrequest Payment Receipt": "Unrequest Payment Receipt",
  "Payments Receipts successfully download!":
    "Payments Receipts successfully download!",
  "Payments Receipts successfully unrequested!":
    "Payments Receipts successfully unrequested!",
  "The selected payments have no receipts generated.":
    "The selected payments have no receipts generated.",
  "Some of the selected payments have no receipts generated and will be omitted.":
    "Some of the selected payments have no receipts generated and will be omitted.",
  "The selected payments already have receipts generated.":
    "The selected payments already have receipts generated.",
  "Some of the selected payments already have receipts generated and will be omitted.":
    "Some of the selected payments already have receipts generated and will be omitted.",
  "The selected payments do not have requested receipts.":
    "The selected payments do not have requested receipts.",
  "Some of the selected payments do not have requested receipts and will be omitted.":
    "Some of the selected payments do not have requested receipts and will be omitted.",
  "Reconciliation": "Reconciliation",
  "Other": "Other",
  "Investment diversification": "Investment diversification",
  "Less than 1hs": "Less than 1hs",
  "1 to 6hs": "1 to 6hs",
  "6 to 12hs": "6 to 12hs",
  "More than 12hs": "More than 12hs",
  "API docs": "API docs",
  "Contact us": "Contact us",
  "Connect your business to the financial ecosystem":
    "Connect your business to the financial ecosystem",
  "Centralize your cash management and gain a comprehensive financial view.":
    "Centralize your cash management and gain a <strong>comprehensive financial view.</strong>",
  "Sign up and get a free trial in just a few minutes. Visualize all your bank accounts in a single web platform.":
    "Sign up and get a free trial in just a few minutes. Visualize all your bank accounts in a single web platform.",
  "Create an account and get a free trial in just a few minutes. No credit card required.":
    "Create an account and get a free trial in just a few minutes. No credit card required.",
  "Start building in our Sandbox environment with sample data.":
    "Start building in our Sandbox environment with sample data.",
  "Try out our APIs and features without coding a single line:":
    "Try out our APIs and features without coding a single line:",
  "Identity.": "Identity.",
  "Accounts.": "Accounts.",
  "Balances.": "Balances.",
  "Transactions.": "Transactions.",
  "Retrieve real financial information for up to 25 free live links.":
    "Retrieve real financial information for up to 25 free live links.",
  "First Name": "First Name",
  "Last Name": "Last Name",
  "Country": "Country",
  "Privacy Policy.": "Privacy Policy.",
  "and": "and",
  "Terms and Conditions": "Terms and Conditions",
  "I accept Datanomik's": "I accept Datanomik's",
  "I accept Datanomiks Terms and Conditions and Privacy Policy.":
    "I accept Datanomiks <2>Terms and Conditions</2> and <6>Privacy Policy</6>.",
  "I agree to the use and processing of my data by Datanomik (Uruguay and Brazil) for commercial purposes and for the improvement of its services.":
    "I agree to the use and processing of my data by Datanomik (Uruguay and Brazil) for commercial purposes and for the improvement of its services.",
  "Create my account": "Create my account",
  "Company name": "Company name",
  "Countries of operation": "Countries of operation",
  "Country of operation": "Country of operation",
  "Mobile": "Mobile",
  "Work area": "Work area",
  "Company type": "Company type",
  "Your clients are": "Your clients are",
  "Use case": "Use case",
  "Number of Institutions": "Number of Institutions",
  "Refresh rate": "Refresh rate",
  "New Password": "New Password",
  "Repeat New Password": "Repeat New Password",
  "Repeat Password": "Repeat Password",
  "Change Password": "Change Password",
  "Help is on the way, please check your email for further instructions.":
    "Help is on the way, please check your email for further instructions.",
  "You haven't added a Link yet.": "You haven't added a Link yet.",
  "Add link": "Add link",
  "Actions": "Actions",
  "Institution": "Institution",
  "Type": "Type",
  "Description": "Description",
  "description": "Description",
  "Last update": "Last update",
  "Detail": "Detail",
  "Edit": "Edit",
  "Delete": "Delete",
  "Add": "Add",
  "Account detail": "Account detail",
  "Investments detail": "Investments detail",
  "Delete Link": "Delete Link",
  "Confirmation": "Confirmation",
  "Are you sure you want to delete this Link?":
    "Are you sure you want to delete this Link?",
  "Are you sure you want to delete this User?":
    "Are you sure you want to delete this User?",
  "Are you sure you want to delete this Account?":
    "Are you sure you want to delete the account?",
  "Edit Link": "Edit Link",
  "Add a Link": "Add a Link",
  "Links exported successfully!": "Links exported successfully!",
  "Transactions exported successfully!": "Transactions exported successfully!",
  "Link edited successfully!": "Link edited successfully!",
  "Category group edited successfully!": "Category group edited successfully!",
  "Account edited successfully!": "Account edited successfully!",
  "General Owner edited successfully!": "General Owner edited successfully!",
  "Owner edited successfully!": "Owner edited successfully!",
  "Account updated successfully!": "Account updated successfully!",
  "Link deleted successfully!": "Link deleted successfully!",
  "Transaction deleted successfully!": "Transaction deleted successfully!",
  "Category group deleted successfully!":
    "Category group deleted successfully!",
  "Account deleted successfully!": "Account deleted successfully!",
  "Bank": "Bank",
  "bank": "bank",
  "Link updated successfully!": "Link updated successfully!",
  "Link created successfully!": "Link created successfully!",
  "Select Country": "Select Country",
  "Select Institution": "Select Institution",
  "Business": "Business",
  "Authentication": "Authentication",
  "Back": "Back",
  "Save": "Save",
  "Credentials not configured yet": "Credentials not configured yet",
  "Edit credentials": "Edit credentials",
  "More fields": "More fields",
  "Fill in manually": "Fill in manually",
  "Scan QR code": "Scan QR code",
  "Upload QR code": "Upload QR code",
  "Manually fill in the digits of the token.":
    "Manually fill in the digits of the token.",
  "Activate the camera and scan the QR code.":
    "Activate the camera and scan the QR code.",
  "Upload a file containing the QR code.":
    "Upload a file containing the QR code.",
  "Requesting camera permissions...": "Requesting camera permissions...",
  "Scan Qr try again":
    "Make sure your device has a camera and that it is activated<br /><2>Try again</2>.",
  "Click here to upload the file with the QR code":
    "Click here to upload the file with the QR code",
  "Virtual account": "Virtual account",
  "Cancel": "Cancel",
  "Copied!": "Copied!",
  "Virtual accounts": "Virtual accounts",
  "Created at": "Created at",
  "Accessed at": "Accessed at",
  "Yes": "Yes",
  "No": "No",
  "Live": "Live",
  "Name": "Name",
  "Email": "Email",
  "Address": "Address",
  "Account": "Account",
  "Phone": "Phone",
  "of": "of",
  "Owner": "Owner",
  "Owner Name": "Owner Name",
  "Type and Number": "Type and Number",
  "Status": "Status",
  "Link status": "Status",
  "Active": "Active",
  "Available": "Available",
  "SUCCESS": "Available",
  "Available Balance": "Available Balance",
  "Current Balance": "Current Balance",
  "Currency": "Currency",
  "Current balance": "Current balance",
  "Account current balance": "Current balance",
  "Investments Gross Value": "Investments Gross Value",
  "Account available balance": "Available balance",
  "Investments Net Value": "Investments Net Value",
  "Available balance": "Available balance",
  "Filters": "Filters",
  "Export": "Export",
  "Filter": "Filter",
  "Clear": "Clear",
  "Columns": "Columns",
  "Density": "Density",
  "active": "active",
  "inactive": "inactive",
  "Inactive": "Inactive",
  "Institution's description": "Institution's description",
  "Invalid credentials": "Invalid credentials",
  "Date": "Date",
  "Amount": "Amount",
  "Initial amount": "Initial amount",
  "Initial date": "Initial date",
  "Balance": "Balance",
  "Reference": "Reference",
  "reference": "Reference",
  "Select a Date Range": "Select a Date Range",
  "Apply": "Apply",
  "Today": "Today",
  "Tomorrow": "Tomorrow",
  "Yesterday": "Yesterday",
  "at": "at",
  "Last 15 minutes": "Last 15 minutes",
  "Last 30 minutes": "Last 30 minutes",
  "Last 1 hour": "Last 1 hour",
  "Last 4 hours": "Last 4 hours",
  "Last 12 hours": "Last 12 hours",
  "Last 24 hours": "Last 24 hours",
  "Last 48 hours": "Last 48 hours",
  "Last 3 days": "Last 3 days",
  "Last 5 days": "Last 5 days",
  "Last 7 days": "Last 7 days",
  "Last 30 days": "Last 30 days",
  "Last 1 month": "Last month",
  "This Month": "This Month",
  "Last Month": "Last Month",
  "This year": "This year",
  "Last 2 months": "Last 2 months",
  "Last 3 months": "Last 3 months",
  "Last 6 months": "Last 6 months",
  "Last 12 months": "Last 12 months",
  "Next 6 months": "Next 6 months",
  "Next 12 months": "Next 12 months",
  "Last 60 days": "Last 60 days",
  "This month": "This month",
  "Last year": "Last year",
  "Quick filter": "Quick filter",
  "Log out": "Log out",
  "Generate": "Generate",
  "You haven't generated a webhook yet.":
    "You haven't generated a webhook yet.",
  "Delete Webhook": "Delete Webhook",
  "Are you sure you want to delete this Webhook?":
    "Are you sure you want to delete this Webhook?",
  "Edit webhook": "Edit webhook",
  "Generate a webhook": "Generate a webhook",
  "Webhook deleted successfully!": "Webhook deleted successfully!",
  "Webhook edited successfully!": "Webhook edited successfully!",
  "Webhook created successfully!": "Webhook created successfully!",
  "Events": "Events",
  "Verified": "Verified",
  "TRANSACTIONS": "Transactions",
  "transactions": "Transactions",
  "ACCOUNTS": "Accounts",
  "accounts": "Accounts",
  "ACCOUNTS_VERIFICATION": "Accounts verification",
  "accounts_verification": "Accounts verification",
  "You don't have any activity yet": "You don't have any activity yet",
  "Start building by generating your": "Start building by generating your",
  "API Keys.": "API Keys.",
  "Request Details": "Request Details",
  "Response": "Response",
  "Success": "Success",
  "Failure": "Failure",
  "Method": "Method",
  "Source": "Source",
  "IP Address": "IP Address",
  "Resource": "Resource",
  "All Resources": "All Resources",
  "All Methods": "All Methods",
  "All Sources": "All Sources",
  "All Status": "All Status",
  "Response code": "Response code",
  "All Response Codes": "All Response Codes",
  "Assets": "Assets",
  "ASSETS": "ASSETS",
  "Balances": "Balances",
  "BALANCES": "BALANCES",
  "LINKS": "Links",
  "Owners": "Owners",
  "label.owners": "Owners",
  "OWNERS": "OWNERS",
  "USERS": "USERS",
  "PLATFORM": "Platform",
  "Credential successfully created!": "Credential successfully created!",
  "Credential successfully saved!": "Credential successfully saved!",
  "Credential successfully deleted!": "Credential successfully deleted!",
  "Create Date": "Create Date",
  "Save changes": "Save",
  "Generate up to 5 API Keys.": "Generate up to 5 API Keys.",
  "Generate API Keys": "Generate API Keys",
  "Start building by generating up to 5 API Keys.":
    "Start building by generating up to 5 API Keys.",
  "Are you sure you want to delete this API Key?":
    "Are you sure you want to delete this API Key?",
  "Delete Key": "Delete Key",
  "Before deleting this API Key, we first recommend you to generate a new one and update your applications.":
    "Before deleting this API Key, we first recommend you to generate a new one and update your applications.",
  "New credential created": "New credential created",
  "We recommend you not to share this information to anyone and also change it from time to time.":
    "We recommend you not to share this information to anyone and also change it from time to time.",
  "This is the only time the secret password can be viewed. Please copy it and/or download both secrets. If you forgot doing so, you can always create a new API Key.":
    "This is the only time the secret password can be viewed. Please copy it and/or download both secrets. If you forgot doing so, you can always create a new API Key.",
  "Secret Password": "Secret Password",
  "Secret ID": "Secret ID",
  "Download CSV": "Download CSV",
  "More Filters": "More Filters",
  "Contact": "Contact",
  "Users": "Users",
  "Role": "Role",
  "Invite a member": "Invite a member",
  "Invite an User": "Invite an User",
  "Disable": "Disable",
  "Enable": "Enable",
  "Send invite": "Send invite",
  "Edit User": "Edit User",
  "ALL": "ALL",
  "All": "All",
  "~ALL~": "All",
  "all": "all",
  "Change password": "Change password",
  "Enter Password": "Enter Password",
  "User successfully enabled!": "User successfully enabled!",
  "User successfully disabled!": "User successfully disabled!",
  "User successfully invited!": "User successfully invited!",
  "User successfully saved!": "User successfully saved!",
  "User successfully deleted!": "User successfully deleted!",
  "Company saved succefully!": "Company data saved successfully!",
  "Company updated succefully!": "Company data updated succefully!",
  "Password changed succefully!": "Password changed succefully!",
  "Profile saved succefully!": "Profile saved succefully!",
  "Total Links": "Total Links",
  "View Details": "View Details",
  "View details": "View details",
  "Links": "Links",
  "links": "Links",
  "Free": "Free",
  "{{freeTrialPeriod}}-days free trial": "{{freeTrialPeriod}}-days free trial",
  "Unlimited test links": "Unlimited test links",
  "{{currency}} {{monthlyCost}}/Month": "{{currency}} {{monthlyCost}}/Month",
  "Including:": "Including:",
  "{{maxPlanIncludedSynCalls}} successful sync calls":
    "{{maxPlanIncludedSynCalls}} successful sync calls",
  "Up to {{maxRecurrentLink}} recurrent links with {{refreshFrequency}}hs refresh frequency":
    "Up to {{maxRecurrentLink}} recurrent links with {{refreshFrequency}}hs refresh frequency",
  "Standard customer service": "Standard customer service",
  "Dedicated account manager": "Dedicated account manager",
  "For additional calls, pay as you go {{currency}} {{exceededPlanSynCallCost}}0 per successful sync call.":
    "For additional calls, pay as you go {{currency}} {{exceededPlanSynCallCost}}0 per successful sync call.",
  "Plans": "Plans",
  "Subscription": "Subscription",
  "Most Popular!": "Most Popular!",
  "Subscription end date": "Subscription end date",
  "Your subcription will be automatically renewed each month":
    "Your subcription will be automatically renewed each month",
  "Available Plans": "Available Plans",
  "Upgrade your plan for more links and data synchronizations.":
    "Upgrade your plan for more links and data synchronizations.",
  "Plus": "Plus",
  "Upgrade Now": "Upgrade Now",
  "Upgrade now": "Upgrade now",
  "Scale": "Scale",
  "Get a custom plan and dedicated support!":
    "Get a custom plan and dedicated support!",
  "Contact Sales": "Contact Sales",
  "Payment method": "Payment method",
  "Card number": "Card number",
  "Document name": "Document name",
  "Document number": "Document number",
  "Scale Plan": "Scale Plan",
  "Upgrade Confirmation": "Upgrade Confirmation",
  "Successful upgrade": "Successful upgrade",
  "Thanks for contacting us, we will contact you as soon as possible":
    "Thanks for contacting us, we will contact you as soon as possible",
  "Starter": "Starter",
  "Active Plan": "Active Plan",
  "Pending Plan": "Pending Plan",
  "Expired Plan": "Expired Plan",
  "Days": "Days",
  "{{cantDays}} of {{totalDays}}": "{{cantDays}} of {{totalDays}}",
  "{{daysRemaining}} days remaining": "{{daysRemaining}} days remaining",
  "We'll contact you to build up the right plan for your business, including:":
    "We'll contact you to build up the right plan for your business, including:",
  "Sandbox environment": "Sandbox environment",
  "Extra recurrent links": "Extra recurrent links",
  "More refresh frequency!": "More refresh frequency!",
  "Select a company type": "Select a company type",
  "Number of one-shot links per month": "Number of one-shot links per month",
  "Number of recurrent links per month": "Number of recurrent links per month",
  "Recurrent Links/Month": "Recurrent Links/Month",
  "Select a frequency interval": "Select a frequency interval",
  "Refresh Frequency": "Refresh Frequency",
  "Select a use case scenario": "Select a use case scenario",
  "Elaborate on why you need these specific things...":
    "Elaborate on why you need these specific things...",
  "Tell us more about your specific needs":
    "Tell us more about your specific needs",
  "Purchase summary": "Purchase summary",
  "Proceed to checkout": "Proceed to checkout",
  "Cardholder name": "Cardholder name",
  "Card Number": "Card Number",
  "Expiration Date": "Expiration Date",
  "Pay": "Pay",
  "Continue": "Continue",
  "Save and continue": "Save and continue",
  "API call evolution": "API call evolution",
  "Success calls": "Success calls",
  "Failed calls": "Failed calls",
  "Total calls": "Total calls",
  "Session expired": "Session expired",
  "Unauthorized": "Unauthorized",
  "API Calls": "API Calls",
  "Monthly": "Monthly",
  "Success Rate": "Success Rate",
  "Failed": "Failed",
  "Recurrent": "Recurrent",
  "One-shot": "One-shot",
  "Compact": "Compact",
  "Standard": "Standard",
  "Comfortable": "Comfortable",
  "Find column": "Find column",
  "Column title": "Column title",
  "Reorder column": "Reorder column",
  "Show all": "Show all",
  "Hide all": "Hide all",
  "Total Current Balance": "Total Current Balance",
  "First name": "First name",
  "Last name": "Last name",
  "Second last name": "Second last name",
  "Change credentials": "Change credentials",
  "Upgrade plan now": "Upgrade plan now",
  "Your subscription has expired on {{validUntil}}.":
    "Your subscription has expired on {{validUntil}}.",
  "Your subscription will expire on {{validUntil}}.":
    "Your subscription will expire on {{validUntil}}.",
  "Until {{validUntil}}": "Until {{validUntil}}",
  "Access denied": "Access denied",
  "7 days": "7 days",
  "15 days": "15 days",
  "30 days": "30 days",
  "Current month": "Current month",
  "No options": "No options",
  "Loading": "Loading...",
  "Basic Information": "Basic Information",
  "Next": "Next",
  "IS REQUIRED": "is required",
  "Submit": "Submit",
  "Write at least 3 characters to start searching":
    "Write at least 3 characters to start searching",
  "We were unable to link the Institution":
    "We were unable to link the Institution",
  "Please verify the information filled in and try again.":
    "Please verify the information filled in and try again.",
  "Try again": "Try again",
  "Validating credentials": "Validating credentials",
  "We're almost done! This can take a few seconds.":
    "We're almost done! This can take a few seconds.",
  "Please don't close this window.": "Please don't close this window.",
  "We are processing the transactions. This can take a few seconds.":
    "We are processing the transactions. This can take a few seconds.",
  "The Institution was successfully linked":
    "The Institution was successfully linked",
  "Profile": "Profile",
  "Supports Widget Recurrent Link": "Supports Widget Recurrent Link",
  "No rows found.": "No rows found.",
  "No rows": "No rows",
  "No results found.": "No results found.",
  "An error occurred.": "An error occurred.",
  "No occurrences": "No occurrences",
  "occurrences": "occurrences",
  "General account status": "General account status",
  "Sender": "Sender",
  "SENDER": "Sender",
  "SENDER_DOCUMENT": "Sender`s Document",
  "Sender detail": "Sender detail",
  "senderName": "Sender",
  "Beneficiary": "Beneficiary",
  "BENEFICIARY": "Beneficiary",
  "BENEFICIARY_DOCUMENT": "Beneficiary`s Document",
  "Beneficiary detail": "Beneficiary detail",
  "beneficiaryName": "Beneficiary",
  "PI_TYPE": "Payment Institution",
  "BANK_TYPE": "Bank Institution",
  "OF_TYPE": "Open Finance",
  "Please confirm us the following information":
    "Please confirm us the following information",
  "Growth Plan": "Growth Plan",
  "Custom Plan": "Custom Plan",
  "Get a tailored plan for your business":
    "Get a tailored plan for your business",
  "Grow your business with our pay-as-you-go plan":
    "Grow your business with our pay-as-you-go plan",
  "The first {{freeTrialPeriod}} days are on us!":
    "The first {{freeTrialPeriod}} days are on us!",
  "More data synchronization / month": "More data synchronization / month",
  "More refresh frequency": "More refresh frequency",
  "No contractual minimums": "No contractual minimums",
  "Up to {{total}} data synchronizations / month":
    "Up to {{total}} data synchronizations / month",
  "{{currency}} {{cost}} per synchronization":
    "{{currency}} {{cost}} per synchronization",
  "{{refreshRate}} hs refresh rate": "{{refreshRate}} hs refresh rate",
  "Requested Plan": "Requested Plan",
  "Subscribe": "Subscribe",
  "Your tailored plan includes:": "Your tailored plan includes:",
  "Blocked account": "Blocked account",
  "Visualize your company's financial data in a single web platform.":
    "Visualize your company's financial data in a single web platform.",
  "Other Plans": "Other Plans",
  "Add Payment Method": "Add Payment Method",
  "Edit Payment Method": "Edit Payment Method",
  "Please select your Payment Method.": "Please select your Payment Method.",
  "The free trial ends on {{validUntil}}.":
    "The free trial ends on {{validUntil}}.",
  "© {{year}} Datanomik. All rights reserved.":
    "© {{year}} Datanomik. All rights reserved.",
  "Admin": "Admin",
  "ADMIN": "Admin",
  "GENERAL_ADMINISTRATOR": "General Administrator",
  "Developer": "Developer",
  "DEVELOPER": "DEVELOPER",
  "Read only": "Read only",
  "The information was successfully updated!":
    "The information was successfully updated!",
  "Refresh": "Refresh",
  "Retrieve Accounts": "Retrieve Accounts",
  "Recovered accounts with success!": "Recovered accounts with success!",
  "READ_ONLY": "Read only",
  "Welcome back to Business Gate": "Welcome to <strong>Datanomik</strong>",
  "Visualize your financial data in a single web platform.":
    "Visualize your financial data in a single web platform.",
  "Understand your company's cash flow and make strategic decisions with Datanomik's Smart Treasury":
    "Understand your company's cash flow and make strategic decisions with <2>Datanomik's</2> <4>Smart Treasury</4>",
  "Have an account?": "Have an account?",
  "Need a help?": "Need a help?",
  "Talk with us": "Talk with us",
  "Sign in": "Sign in",
  "Create your account": "Create your account",
  "Log in to your account": "Log in to your account",
  "Welcome back {{firstName}}!": "Welcome back {{firstName}}!",
  "Check out your financial overview": "Check out your financial overview",
  "than last day": "than last day",
  "Last update: {{lastUpdate}}": "Last update: {{lastUpdate}}",
  "Without activity": "Without activity",
  "Current Balance / Institution": "Current Balance / Institution",
  "Current Balance / Owner Tag": "Current Balance / Owner Tag",
  "Current Balance / Account Tag": "Current Balance / Account Tag",
  "Current Balance / Account group": "Current Balance / Account group",
  "Current Balance / Owner": "Current Balance / Owner",
  "Current Balance / Country": "Current Balance / Country",
  "Without data": "Without data",
  "Overview": "Overview",
  "Debits": "Debits",
  "in Debits": "in Debits",
  "Credits": "Credits",
  "in Credits": "in Credits",
  "Date Range": "Date Range",
  "Inflows, outflows and balance evolution":
    "Inflows, outflows and balance evolution",
  "Balance evolution": "Balance evolution",
  "Inflows and Outflows": "Inflows and Outflows",
  "Show balance": "Show balance",
  "Show projected": "Show projected",
  "Hide empty categories": "Hide empty categories",
  "Showing only with values": "Showing only with values",
  "Showing all categories": "Showing all categories",
  "Period too long for daily view": "Period too long for daily view",
  "For better visualization, we recommend using Weekly or Monthly grouping":
    "For better visualization, we recommend using Weekly or Monthly grouping",
  "Inflow per Institution": "Inflow per Institution",
  "Outflow per Institution": "Outflow per Institution",
  "Net per Institution": "Net per Institution",
  "Net": "Net",
  "Net position per Institution": "Net position per Institution",
  "Net position": "Net position",
  "Total Net position": "Net position",
  "REQUESTED": "Requested",
  "Requested": "Requested",
  "IN_PROGRESS": "In progress",
  "PROCESSED": "Processed",
  "Processed": "Processed",
  "Settings": "Settings",
  "Link description": "Link description",
  "Link": "Link",
  "Verify": "Verify",
  "From": "From",
  "To": "To",
  "Card": "Card",
  "CREDIT": "Card",
  "Bank Transfer": "Bank Transfer",
  "TRANSFER": "Bank Transfer",
  "You are in test mode.": "You are in test mode.",
  "Please do not enter real bank credentials.":
    "Please do not enter real bank credentials.",
  "Yes, continue": "Yes, continue",
  "No, go to production": "No, go to production",
  "Language of preference": "Language of preference",
  "BANK": "Bank",
  "PI": "Payment Institution",
  "Pi": "Payment Institution",
  "pi": "Payment Institution",
  "OF": "Open Finance",
  "Inflow": "Inflow",
  "Outflow": "Outflow",
  "INFLOW": "Inflow",
  "OUTFLOW": "Outflow",
  "Welcome to Business Gate": "Welcome to Business Gate",
  "Set up your dashboard in 3 single steps and centralize your company's financial data in real-time.":
    "Set up your dashboard in 3 single steps and centralize your company's financial data in real-time.",
  "Connect my institutions": "Connect my institutions",
  "or try with test data": "or try with test data",
  "Refresh rate (mins)": "Refresh rate (mins)",
  "The minimum refresh rate is {{min}} minutes":
    "The minimum refresh rate is {{min}} minutes",
  "or try with test data on Sandbox environment":
    "or try with test data on Sandbox environment",
  "Fixed deposit": "Fixed deposit",
  "fixed deposit": "Fixed deposit",
  "Expand": "Expand",
  "Collapse": "Collapse",
  "Related links": "Related links",
  "Related users": "Related users",
  "Virtual links": "Virtual Links",
  "Add new virtual link": "Add new Virtual Link",
  "Edit virtual link": "Edit Virtual Link",
  "Delete Virtual link": "Delete Virtual Link",
  "Are you sure you want to delete this Virtual link?":
    "Are you sure you want to delete this Virtual Link?",
  "Virtual link successfully deleted!": "Virtual Link successfully deleted!",
  "Virtual link successfully!": "Virtual Link successfully created!",
  "Virtual link successfully saved!": "Virtual Link successfully saved!",
  "COUNT_SELECTED_zero": "0 selected",
  "COUNT_SELECTED_one": "1 selected",
  "COUNT_SELECTED_other": "{{count}} selected",
  "Available Links": "Available Links",
  "Selected Links": "Selected Links",
  "Available Users": "Available Users",
  "Selected Users": "Selected Users",
  "No Data": "No Data",
  "Assign links": "Assign links",
  "Assign users": "Assign users",
  "{{x}} account/s with negative balance":
    "{{x}} account/s with negative balance",
  "Reset link sent!": "Reset link sent!",
  "Authentication Type": "Authentication Type",
  "ACCOUNT": "Account",
  "BALANCE": "Balance",
  "Current account balance": "Balance",
  "AMOUNT": "Amount",
  "EQUALS": "Equals",
  "PAYMENT": "Payment",
  "PAYMENTS": "Payments",
  "INVESTMENT_MOVEMENTS": "Investment Movements",
  "PAYMENT_RECEIPT": "Payment receipt",
  "PIX_TRANSACTION": "Pix",
  "PERIOD_STATEMENT": "Period statement",
  "MONTHLY": "Monthly",
  "TRANSACTION": "Transaction",
  "DESCRIPTION": "Description",
  "EXTERNAL_ID": "External ID",
  "CONTAINS": "Contains",
  "NOT_CONTAINS": "Not contains",
  "STARTS_WITH": "Starts with",
  "ENDS_WITH": "Ends with",
  "GREATER_THAN": "Greater than",
  "LESS_THAN": "Less than",
  "BETWEEN": "Between",
  "REFERENCE": "Reference",
  "STATUS": "Status",
  "Variable": "Variable",
  "Attribute": "Attribute",
  "Condition": "Condition",
  "Value": "Value",
  "Channel": "Channel",
  "Channels": "Channels",
  "View Rule": "View Rule",
  "Are you sure you want to delete this Rule?":
    "Are you sure you want to delete this Rule?",
  "Add new Rule": "Add new Rule",
  "EMAIL": "Email",
  "Notifications": "Notifications",
  "Roles reference": "Roles reference",
  "can access every module of the platform with all the permissions.":
    "can access every module of the platform with all the permissions.",
  "has access to the financial modules of the platform. Can add, edit, refresh and delete links.":
    "has access to the financial modules of the platform. Can add, edit, refresh and delete links.",
  "has access only to the technical modules of the platform.":
    "has access only to the technical modules of the platform.",
  "similar to the Finance role, but can't add links.":
    "similar to the Finance role, but can't add links.",
  "en": "English",
  "es": "Spanish",
  "pt": "Portuguese",
  "Rule created successfully!": "Rule created successfully!",
  "Rule deleted successfully!": "Rule deleted successfully!",
  "Rule updated successfully!": "Rule updated successfully!",
  "Edit Rule": "Edit Rule",
  "linkId": "Link description",
  "institutionId": "Institution",
  "institutionName": "Institution",
  "ownerId": "Owner",
  "generalOwnerId": "Owner",
  "type": "Type",
  "availableBalanceLte": "Available balance <=",
  "availableBalanceGte": "Available balance >=",
  "currentBalanceGte": "Current balance >=",
  "currentBalanceLte": "Current balance <=",
  "availablePositionLte": "Available position <=",
  "availablePositionGte": "Available position >=",
  "currentPositionGte": "Current position >=",
  "currentPositionLte": "Current position <=",
  "accountId": "Account",
  "currency": "Currency",
  "dateFrom": "Date from",
  "dateFromHistory": "Date from",
  "dateTo": "Date to",
  "dateToHistory": "Date to",
  "trxType": "Type",
  "amountTo": "Amount <=",
  "amountFrom": "Amount >=",
  "feeTo": "Fee <=",
  "feeFrom": "Fee >=",
  "source": "Source",
  "module": "Resources",
  "httpMethod": "Method",
  "responseStatus": "Status",
  "httpResponseStatus": "Response code",
  "Point of Contact": "Point of Contact",
  "Severity": "Priority",
  "Lowest": "Lowest",
  "Low": "Low",
  "Medium": "Medium",
  "High": "High",
  "Highest": "Highest",
  "You have {{x}} new message/s!": "You have {{x}} new message/s!",
  "Mark all as read": "Mark all as read",
  "Only show unread": "Only show unread",
  "History": "History",
  "View detail": "View detail",
  "Mark as unread": "Mark as unread",
  "Mark as read": "Mark as read",
  "Your credentials are securely encrypted":
    "Your credentials are securely encrypted",
  "Institution successfully linked!": "Institution successfully linked!",
  "We're processing transactions, this might take a while to reflect on the dashboard.":
    "We're processing transactions, this might take a while to reflect on the dashboard.",
  "To read the full list please view the account detail":
    "To read the full list please view the account detail",
  "For a refresh rate under {{frequency}} min, please contact our sales team.":
    "For a refresh rate under {{frequency}} min, please contact our sales team.",
  "Close": "Close",
  "Connect": "Connect",
  "Credentials": "Credentials",
  "Step {{x}}": "Step {{x}}",
  "See all notifications": "See all notifications",
  "Identification": "Identification",
  "Rules": "Rules",
  "name": "Name",
  "value": "Value",
  "email": "Email",
  "resource": "Variable",
  "Module": "Module",
  "field": "Attribute",
  "constraint": "Condition",
  "severity": "Priority",
  "Billing history": "Billing",
  "Period": "Period",
  "Plan": "Plan",
  "Synchronizations": "Synchronizations",
  "Price (USD)": "Price (USD)",
  "Amount (USD)": "Amount (USD)",
  "The account <strong>{{accountNumber}}</strong> has been blocked by the Institution.":
    "The account <strong>{{accountNumber}}</strong> has been blocked by the Institution.",
  "The account <strong>{{accountNumber}}</strong> has a balance equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> has a balance equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> has a balance higher than {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> has a balance higher than {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> has a balance lower than {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> has a balance lower than {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> has a judicial blocked balance higher than {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> has a judicial blocked balance higher than {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> has a balance between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.":
    "The account <strong>{{accountNumber}}</strong> has a balance between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an amount equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with an amount equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an amount higher than {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with an amount higher than {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an amount lower than {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with an amount lower than {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an amount between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with an amount between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a fee equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a fee equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a fee higher than {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a fee higher than {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a fee lower than {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a fee lower than {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a fee between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a fee between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that not contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that not contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that starts with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that starts with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that ends with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that ends with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that not contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that not contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that starts with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that starts with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that ends with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that ends with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a description equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a description equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a description that contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a description that contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a description that not contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a description that not contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a description that starts with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a description that starts with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a description that ends with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a description that ends with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a category equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a category equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that not contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that not contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that starts with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that starts with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that ends with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that ends with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that not contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that not contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that starts with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that starts with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that ends with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that ends with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document that contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document that contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document that not contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document that not contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document that starts with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document that starts with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document that ends with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document that ends with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document that contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document that contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document that not contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document that not contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document that starts with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document that starts with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document that ends with {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document that ends with {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with an amount equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with an amount equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with an amount higher than {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with an amount higher than {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with an amount lower than {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with an amount lower than {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with an amount between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with an amount between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a reference equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with a reference equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a reference that contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with a reference that contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a description equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with a description equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a description that contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with a description that contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a category equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with a category equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary that contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary that contains {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary's document equal to {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary's document equal to {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary's document that contains {{constraintValue}}.":
    "The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary's document that contains {{constraintValue}}.",
  "Approved": "Approved",
  "Expired": "Expired",
  "Created": "Created",
  "Blocked": "Blocked",
  "User blocked": "Blocked",
  "Refused": "Refused",
  "Pending": "Pending",
  "APPROVED": "Approved",
  "EXPIRED": "Expired",
  "CREATED": "Created",
  "BLOCKED": "Blocked",
  "REFUSED": "Refused",
  "PENDING": "Pending",
  "Billing information": "Billing information",
  "Please complete the billing information":
    "Please first complete the billing information",
  "Fiscal Number": "Fiscal Number",
  "Billing information successfully saved!":
    "Billing information successfully saved!",
  "Edit Billing information": "Edit Billing information",
  "Conditions": "Conditions",
  "Never": "Never",
  "Finalize": "Finalize",
  "Time from": "Time from",
  "Time to": "Time to",
  "When condition is met": "When condition is met",
  "Assign accounts": "Assign accounts",
  "Available accounts": "Available accounts",
  "Selected accounts": "Selected accounts",
  "Expand all": "Expand all",
  "Collapse all": "Collapse all",
  "transactionId": "Transaction ID",
  "STAGE_ALPHA": "Alpha",
  "STAGE_BETA": "Beta",
  "STAGE_STABLE": "Stable",
  "Main currency": "Main currency",
  "Set main currency": "Set main currency",
  "Collapse menu": "Collapse menu",
  "Expand menu": "Expand menu",
  "virtualLinkId": "Virtual Link",
  "limitDate": "Limit date",
  "Limit date": "Limit date",
  "There is no active plan in order to be able to establish a new link.":
    "There is no active plan in order to be able to establish a new link.",
  "It appears you don't have permissions to access this page":
    "It appears you don't have permissions to access this page",
  "Back to home page": "Back to home page",
  "Invalid username or password": "Invalid username or password",
  "Request": "Request",
  "Request history": "Request history",
  "Date range": "Date range",
  "{{institution}} allows consulting historic information up to {{maxRecoveryMonth}} months.":
    "{{institution}} allows consulting historic information up to {{maxRecoveryMonth}} months.",
  "Select a date range": "Select a date range",
  "transactionStatus": "Transaction status",
  "Processing": "Processing",
  "Processing Accounts": "Processing Accounts",
  "Processing Transactions": "Processing Transactions",
  "We are still processing transactions for some Links.":
    "We are still processing transactions for some Links.",
  "Company details": "Company details",
  "Point of contact": "Point of contact",
  "Check Rates": "Check Rates",
  "Currency rates": "Currency rates",
  "Historic rates": "Historic rates",
  "We are still processing the accounts and balances.":
    "We are still processing the accounts and balances.",
  "We are still processing the accounts and balances for some Links.":
    "We are still processing the accounts and balances for some Links.",
  "We're processing the information, this might take a while to reflect on the dashboard.":
    "We're processing the information, this might take a while to reflect on the dashboard.",
  "Let’s get you started with Datanomik, please take a look at the following steps.":
    "Let’s get you started with Datanomik, please take a look at the following steps.",
  "Creating a link": "Creating a link",
  "Three steps are required to create a new link: select country, select institution, and login.":
    "Three steps are required to create a new link: select country, select institution, and login.",
  "Create link": "Create link",
  "...or test with fake data": "...or test with fake data",
  "User": "Users",
  "Invite your team to Business Gate and assign roles. They will be able to set up their own accounts.":
    "Invite your team to Business Gate and assign roles. They will be able to set up their own accounts.",
  "Invite user": "Invite user",
  "Connect our APIs": "Connect our APIs",
  "Developer roles": "Developer roles",
  "Create a developer profile within Business Gate to integrate our APIs.":
    "Create a developer profile within Business Gate to integrate our APIs.",
  "Create a developer profile": "Create a developer profile",
  "Generate up to 5 API Keys and test with sample and real data through a sandbox environment.":
    "Generate up to 5 API Keys and test with sample and real data through a sandbox environment.",
  "Integrate APIs": "Integrate APIs",
  "Forget lengthy and costly integrations. Set up Datanomik’s APIs with just a few lines of code.":
    "Forget lengthy and costly integrations. Set up Datanomik’s APIs with just a few lines of code.",
  "Read API docs": "Read API docs",
  "CURRENT_BALANCE_ACCOUNT_TAG_INFO_TEXT":
    "This chart presents how your balances in each currency are distributed by account tag.",
  "CURRENT_BALANCE_ACCOUNT_GROUP_INFO_TEXT":
    "This chart presents how your balances in each currency are distributed by account group.",
  "CURRENT_BALANCE_GENERAL_OWNER_TAG_INFO_TEXT":
    "This chart presents how your balances in each currency are distributed by owner tag.",
  "CURRENT_BALANCE_INSTITUTION_INFO_TEXT":
    "This chart presents how your balances in each currency are distributed by institution.",
  "CURRENT_BALANCE_GENERAL_OWNER_INFO_TEXT":
    "This chart presents how your balances in each currency are distributed by owner.",
  "CURRENT_BALANCE_COUNTRY_INFO_TEXT":
    "This chart presents how your balances in each currency are distributed by country.",
  "NET_POSITION_PER_INSTITUTION_INFO_TEXT":
    "This chart presents the sum of inflows and outflows by institution, and the resulting net position. Can apply filters.",
  "CREDITS_DEBITS_AND_BALANCE_EVOLUTION_INFO_TEXT":
    "This chart presents how balances, inflows and outflows evolve over time. Can apply filters.",
  "BALANCE_EVOLUTION_INFO_TEXT":
    "This chart presents how balances evolve over time. Can apply filters.",
  "LINK_DESCRIPTION_FIELD_INFO_TEXT":
    "Set up a description for this Institution. You’ll be able to use it as a tool to filter & identify it easier.",
  "TOTAL_CURRENT_BALANCE_INFO_TEXT":
    "This section presents the sum of the current balances in each currency of all links. Check the latest updates.",
  "I’m not sure which credentials I should use...":
    "I’m not sure which credentials I should use...",
  "We use the highest security standards to protect all information end-to-end":
    "We use the highest security standards to protect all information end-to-end",
  "LINK_MODAL_INFO_TEXT":
    "You’ll be required to set up credentials to access each institution. We recommend creating a dedicated user for <strong>Business Gate’s</strong> exclusive use only.",
  "LINK_MODAL_CREDENTIALS_INFO_TEXT":
    "To link your account, please fill the fields with the credentials you use to access your bank.",
  "Go Back": "Back",
  "Invalid Email": "Invalid Email",
  "Default Virtual link": "Default Virtual link",
  "VIRTUAL_LINK_INFO_TEXT":
    "This functionality allows you to create groups of links and grant access to the corresponding users.<br /><br />Users with <strong>Finance</strong> or <strong>Read Only</strong> roles can be related to several Virtual Links. <strong>Admins</strong> have full access to all the financial information.",
  "DEFAULT_VIRTUAL_LINK_INFO_TEXT":
    "The related users will have access to view all the financial information, without restrictions.",
  "Categories": "Categories",
  "Remove": "Remove",
  "Add Child": "Add Child",
  "Add new category": "Add new category",
  "Inflows": "Inflows",
  "Outflows": "Outflows",
  "Are you sure you want to delete this Category?":
    "Are you sure you want to delete this Category?",
  "Related rules will also be removed": "Related rules will also be removed.",
  "Subcategories will also be removed": "Subcategories will also be removed.",
  "New category": "New category",
  "Parent category": "Parent category",
  "Parent group": "Parent group",
  "Color": "Color",
  "Create new rule": "Create new rule",
  "Create new category": "Create new category",
  "Edit rule": "Edit rule",
  "Create": "Create",
  "Add a Category group": "Add a Category group",
  "Edit a Category group": "Edit a Category group",
  "Related Categories": "Related Categories",
  "Are you sure you want to delete this Category rule?":
    "Are you sure you want to delete this Category rule?",
  "Category successfully!": "Category successfully!",
  "Category successfully saved!": "Category successfully saved!",
  "Category rule successfully!": "Category rule successfully!",
  "Category rule successfully saved!": "Category rule successfully saved!",
  "Category rule successfully deleted!": "Category rule successfully deleted!",
  "Category successfully deleted!": "Category successfully deleted!",
  "Related rules and Subcategories will also be removed":
    "Related rules and Subcategories will also be removed",
  "Edit transaction categories": "Edit transaction categories",
  "Edit Batch payments categories": "Edit Batch payments categories",
  "Edit Pix categories": "Edit Pix categories",
  "Categories successfully saved!": "Categories successfully saved!",
  "categoryId": "Category",
  "CATEGORY": "Category",
  "Category": "Category",
  "Uruguay - CI": "Uruguay - CI",
  "Argentina - DNI": "Argentina - DNI",
  "Brasil - CI": "Brazil - CI",
  "At least one rule is required.": "At least one rule is required.",
  "Last day balance": "Last day balance",
  "Add users": "Add users",
  "Save and close": "Save and close",
  "You can assign the users at another time.":
    "You can assign the users at another time.",
  "MAIN_CURRENCY_FIELD_INFO_TEXT":
    "Allows you to select a reference currency, to display the amounts expressed in a single currency.",
  "Status (only Payment Institution)": "Status (only Payment Institution)",
  "Reset": "Reset",
  "Rate edited successfully!": "Rate edited successfully!",
  "Rate restarted successfully!": "Rate restarted successfully!",
  "Currencies": "Currencies",
  "Activation email sent successfully": "Activation email sent successfully!",
  "Show inactive accounts": "Show inactive accounts",
  "Not connected": "Not connected",
  "We couldn't process this Link.": "We couldn't process this Link.",
  "status": "Status",
  "country": "Country",
  "Last day": "Last day balance",
  "Beginning of day": "Beginning of day balance",
  "Mode": "Mode",
  "mode": "Mode",
  "AUTOMATIC": "Automatic",
  "MANUAL": "Manual",
  "MANUAL_DEPOSIT": "CDBs to expire",
  "MANUAL_COMMITTED": "Committed to expire",
  "Secondary Point of contact": "Secondary Point of contact",
  "Group by": "Group by",
  "Group by Owner": "Group by Owner",
  "Search and filter by Currency, Owner, Institution":
    "Search and filter by Currency, Owner, Institution",
  "Number": "Number",
  "Branch": "Branch",
  "Transaction data": "Transaction data",
  "Application data": "Application data",
  "Institution detail": "Institution detail",
  "Copy detail": "Copy detail",
  "Information not valid as receipt": "Information not valid as receipt",
  "Transaction detail": "Transaction detail",
  "INSTITUTION DETAIL": "Institution detail",
  "ACCOUNT DETAIL": "Account detail",
  "INVESTMENT DETAIL": "Investment detail",
  "TRANSACTION DATA": "Transaction data",
  "ADDITIONAL INFORMATION": "Additional information",
  "Links created": "Links created",
  "Workspace successfully created!": "Workspace successfully created!",
  "Workspace successfully saved!": "Workspace successfully saved!",
  "Workspace successfully deleted!": "Workspace successfully deleted!",
  "View Workspace": "View Workspace",
  "Create a Workspace": "Create a Workspace",
  "Edit Workspace": "Edit Workspace",
  "Are you sure you want to delete this Workspace?":
    "Are you sure you want to delete this Workspace?",
  "Pending Device Registration": "Pending Device Registration",
  "An admin/master user must approve the registration of the device":
    "An admin/master user must approve the registration of the device",
  "Device registration": "Device registration",
  "Almost there!": "Almost there!",
  "This institution requieres an Admin user to approve this registration in order to start processing information.":
    "This institution requieres an Admin user to approve this registration in order to start processing information.",
  "None": "None",
  "Some links need to be updated manually. Please update them.":
    "Some links need to be updated manually. Please update them.",
  "Some accounts are not updated. Please update them.":
    "Some accounts were not updated today yet. Please update them.",
  "UP_TO_DATE_YES": "Yes",
  "UP_TO_DATE_NO": "No",
  "Updated on the day": "Updated today",
  "upToDate": "Updated today",
  "View accounts": "View accounts",
  "The information is being processed. {{linksCount}} links have been sent for processing.":
    "The information is being processed. {{linksCount}} links have been sent for processing.",
  "The information is being processed.": "The information is being processed.",
  "in process": "in process",
  "Fee": "Fee",
  "FEE": "Fee",
  "Service Cost": "Service Cost",
  "Taxes": "Taxes",
  "Tax": "Tax",
  "Sale Method": "Sale Method",
  "Voucher": "Voucher",
  "Masked Card": "Card",
  "Check Serial Number": "Check Serial Number",
  "Check Number": "Check Number",
  "Are you sure you want to disable the account?":
    "Are you sure you want to disable the account?",
  "Create a dedicated space to share specific financial information with users within a workspace.":
    "Create a dedicated space to share specific financial information with users within a workspace.",
  "administrates the subscription and all the workspaces.":
    "Administrates the subscription and all the workspaces.",
  "has all the permissions to administrate a workspace.":
    "Has all the permissions to administrate a workspace.",
  "has access to financial information. Can add and refresh links.":
    "Has access to financial information. Can add and refresh links.",
  "has access only to the technical modules.":
    "Has access only to the technical modules.",
  "similar to the Finance role, but can't add/refresh links.":
    "Similar to the Finance role, but can't add/refresh links.",
  "Share specific financial information with other users within a workspace.":
    "Share specific financial information with other users within a workspace.",
  "What would you like to name your Workspace?":
    "What would you like to name your Workspace?",
  "Every customer starts with one workspace. You can create more depending on the financial information you need to share with specific users based on their role within your company.":
    "Every customer starts with one workspace. You can create more depending on the financial information you need to share with specific users based on their role within your company.",
  "General Admin": "General Admin",
  "Workspaces": "Workspaces",
  "Workspace": "Workspace",
  "{{company}}'s workspaces": "{{company}}'s workspaces",
  "{{company}}'s views": "{{company}}'s views",
  "Check out the workspaces already available.":
    "Check out the workspaces already available.",
  "Identity": "Identity",
  "Activate": "Activate",
  "Security": "Security",
  "User Activation": "User Activation",
  "Please login to activate the workspace.":
    "Please login to activate the workspace.",
  "Back to login page": "Back to login page",
  "Workspace successfully activated!": "Workspace successfully activated!",
  "Workspace is being activated": "Workspace is being activated",
  "Copy": "Copy",
  "Link info": "Link information",
  "Account info": "Account information",
  "N° account": "N° account",
  "PERIOD_ONE_TIME": "Does not repeat",
  "PERIOD_MONTHLY": "Monthly on {{day}}",
  "PERIOD_WEEKLY": "Weekly on {{day}}",
  "PERIOD_WEEKDAY": "Monday to Friday",
  "PERIOD_MONDAY_TO_SATURDAY": "Monday to Saturday",
  "PERIOD_EVERYDAY": "Every day",
  "PERIOD_WEEKEND": "Weekend",
  "PERIOD_START_OF_MONTH": "Start of Month",
  "Sync Mode": "Sync Mode",
  "Sync Type": "Sync Type",
  "Information to sync": "Information to sync",
  "Sync period": "Sync period",
  "SYNC_MODES_ACCOUNT": "Accounts balances",
  "SYNC_MODES_TRANSACTION": "Transactions",
  "SYNC_MODES_INVESTMENT": "Investments",
  "SYNC_MODES_PAYMENT": "Payments",
  "SYNC_MODES_INVESTMENT_MOVEMENT": "Investment movements",
  "SYNC_MODES_PAYMENT_RECEIPT": "Payment Receipts",
  "SYNC_MODES_PAYMENT_SLIP": "Payment Slips",
  "SYNC_MODES_PIX_TRANSACTION": "Pix",
  "SYNC_MODES_PERIOD_STATEMENT": "Period statement",
  "SYNC_MODES_MONTHLY": "Monthly",
  "SYNC_MODES_ALL": "All",
  "Schedule refresh": "Schedule refresh",
  "Are you sure you want to delete this schedule?":
    "Are you sure you want to delete this schedule?",
  "Schedule successfully saved!": "Schedule successfully saved!",
  "Schedule created successfully!": "Schedule created successfully!",
  "Start refresh at": "Starts at",
  "Time": "Time",
  "Recurrence": "Recurrence",
  "My workspaces": "My workspaces",
  "{{workspaceName}}'s users": "{{workspaceName}}'s users",
  "Pending confirmation": "Pending confirmation",
  "Pending invitation": "Pending invitation",
  "Successfully unsubscribed!": "Successfully unsubscribed!",
  "Are you sure you want to unsubscribe this Workspace?":
    "Are you sure you want to unsubscribe this Workspace?",
  "Invitation": "Invitation",
  "Accept": "Accept",
  "Decline": "Decline",
  "Unsubscribe": "Unsubscribe",
  "Percentage": "Percentage",
  "Copy information": "Copy information",
  "Workspace successfully abandoned!": "Workspace successfully abandoned!",
  "View successfully abandoned!": "View successfully abandoned!",
  "Are you sure you want to abandon this Workspace?":
    "Are you sure you want to abandon this Workspace?",
  "Abandon": "Abandon",
  "Account category": "Account category",
  "SAVING": "Saving account",
  "CHECKING": "Checking account",
  "ESCROW": "Escrow account",
  "INVESTMENT": "Investment",
  "INVESTMENTS": "Investments",
  "FOOD": "Food account",
  "FIXED_DEPOSIT": "Fixed deposit",
  "AUTOMATIC_APP": "Automatic Application",
  "CAPITAL_ACCOUNT": "Capital account",
  "New schedule": "New schedule",
  "Welcome {{firstName}}!": "Welcome {{firstName}}!",
  "Let’s get you started with Datanomik. Please take a look at the following steps.":
    "Let’s get you started with Datanomik. Please take a look at the following steps.",
  "Manage workspaces": "Manage workspaces",
  "Manage views": "Manage views",
  "Workspace has been created! Through the settings menu, you can add more workspaces and share them with other users later.":
    "Workspace has been created! Through the settings menu, you can add more workspaces and share them with other users later.",
  "Invite new users to this workspace. They will have access to the modules according to the assigned role.":
    "Invite new users to this workspace. They will have access to the modules according to the assigned role.",
  "Link your institutions. Normally in 3 single steps you can start visualizing financial information.":
    "Link your institutions. Normally in 3 single steps you can start visualizing financial information.",
  "Create a Link": "Create a Link",
  "CREATE_LINK_INFO":
    "<strong>Important:</strong> The information will be available only within the workspace in which the link is created.",
  "Connect APIs": "Connect APIs",
  "Invite": "Invite",
  "Add developers to integrate our APIs.":
    "Add developers to integrate our APIs.",
  "Forget lengthy and costly integrations.":
    "Forget lengthy and costly integrations.",
  "Skip": "Skip",
  "Thanks for choosing Datanomik’s Business Gate to manage your finances in one place.":
    "Thanks for choosing Datanomik’s Business Gate to manage your finances in one place.",
  "Set up your accounts & gain access to a full financial overview.":
    "Set up your accounts & gain access to a full financial overview.",
  "Speed up decision making by visualizing all balances in one place.":
    "Speed up decision making by visualizing all balances in one place.",
  "Analyze transactional data and improve reconciliation processes.":
    "Analyze transactional data and improve reconciliation processes.",
  "Invite other users to join Business Gate. Share workspaces and their specific financial information.":
    "Invite other users to join Business Gate. Share workspaces and their specific financial information.",
  "Link your institutions to the platform and start using Business Gate.":
    "Link your institutions to the platform and start using Business Gate.",
  "Connect your institutions to the platform and take advantage of Business Gate.":
    "Connect your institutions to the platform and take advantage of Business Gate.",
  "Will you be the one to connect all of your institutions? If this is not the case, don't worry; you may skip this step and invite new users later.":
    "Will you be the one to connect all of your institutions? If this is not the case, don't worry; you may skip this step and invite new users later.",
  "Start": "Start",
  "Default Workspace successfully saved!":
    "Default Workspace successfully saved!",
  "Edit credential": "Edit credential",
  "You have some negative balances": "You have some negative balances",
  "It seems there are no links created in this workspace.":
    "It seems there are no links created in this workspace.",
  "Start linking institutions in 3 singles steps: select country, select institution, and login. That’s it!":
    "Start linking institutions in 3 singles steps: select country, select institution, and login. That’s it!",
  "*Every user in this workspace will be able to access information of the links you create.":
    "*Every user in this workspace will be able to access information of the links you create.",
  "Please contact your workspace admin for more information.":
    "Please contact your workspace admin for more information.",
  "Document": "Document",
  "Document Type": "Document Type",
  "Check last updates": "Check last updates",
  "Active clients": "Active companies",
  "Select Client": "Select company",
  "Change Client": "Change Client",
  "Swift code": "Swift code",
  "Net Value": "Net Value",
  "Gross Value": "Gross Value",
  "Gross value": "Gross value",
  "Type of investment": "Type of investment",
  "netBalanceLte": "Net Value <=",
  "netBalanceGte": "Net Value >=",
  "grossBalanceGte": "Gross Value >=",
  "grossBalanceLte": "Gross Value <=",
  "STOCKS": "Stocks",
  "BOND": "Bond",
  "FUND": "Fund",
  "DEPOSIT": "Fixed income",
  "DEPOSIT,COMMITTED": "Fixed income",
  "COE": "COE",
  "Coe": "COE",
  "COMMITTED": "Committed",
  "Show investments": "Show investments",
  "Hide investments": "Hide investments",
  "Last day position": "Last day position",
  "Beginning of day position": "Beginning of day position",
  "Current position": "Current position",
  "Current": "Current",
  "Applications": "Applications",
  "Operation": "Operation",
  "Instrument": "Instrument",
  "instrumentType": "Instrument",
  "Expiration": "Expiration",
  "dueDate": "Expiration",
  "Application expired": "Expires today",
  "Applied value": "Applied value",
  "Return": "Return",
  "Current value": "Current value",
  "Profit ($)": "Profit ($)",
  "Profit": "Profit",
  "Gross Profit": "Gross Profit",
  "Net Profit": "Net Profit",
  "Date application": "Application date",
  "Application date": "Application date",
  "Applications detail": "Applications detail",
  "Position": "Position",
  "Available position": "Available position",
  "Investments": "Investments",
  "Installments": "Installments",
  "Cash Position": "Cash Position",
  "Forecasted Cash Position": "Forecasted Cash Position",
  "Position in {{currency}}": "Position in {{currency}}",
  "The maximum size is 64 characters": "The maximum size is 64 characters",
  "The maximum size is 128 characters": "The maximum size is 128 characters",
  "USER": "User",
  "General Administrators": "General Administrators",
  "Add new General Admin": "Add new General Admin",
  "New General Admin": "New General Admin",
  "Please select a registered User in order to assign this category":
    "Please select a registered User in order to assign this category",
  "General admin successfully saved!": "General admin successfully saved!",
  "General admin successfully removed!": "General admin successfully removed!",
  "Remove category": "Remove category",
  "Are you sure you want to remove him/her as General Administrator?":
    "Are you sure you want to remove him/her as General Administrator?",
  "Reports": "Reports",
  "Report": "Report",
  "Transactions Report": "Transactions Report",
  "You do not have assigned workspaces": "You do not have assigned workspaces",
  "{{from}}-{{to}} of {{count}} records":
    "{{from}}-{{to}} of {{count}} records",
  "Something went wrong!": "Something went wrong!",
  "Customize your own reports!": "Customize your own reports!",
  "Select one of the following options and create your financial reports":
    "Select one of the following options and create your financial reports",
  "Create a Report": "Create a Report",
  "Generate Report": "Generate Report",
  "New report": "New report",
  "label.consolidatedPositionByDay": "Consolidated position by day",
  "Consolidated balances per account groups by date.":
    "Consolidated balances per account groups by date.",
  "Contains information of your accounts and balances":
    "Contains information of your accounts and balances",
  "Contains information of all the debits and credits in your accounts":
    "Contains information of all the debits and credits in your accounts",
  "Permissions": "Permissions",
  "Workspace Permissions: {{workspace}}":
    "Workspace Permissions: {{workspace}}",
  "Group": "Group",
  "Create group": "Create group",
  "Save group": "Save group",
  "New Group": "New Group",
  "New permission": "New",
  "Permission group successfully saved!":
    "Permission group successfully saved!",
  "Permission group successfully updated!":
    "Permission group successfully updated!",
  "Are you sure you want to remove this permission group?":
    "Are you sure you want to remove this permission group?",
  "Permission group successfully deleted!":
    "Permission group successfully deleted!",
  "Group Name": "Group Name",
  "In order to limit user access to links inside a workspace, define groups of permissions.":
    "In order to limit user access to links inside a workspace, define groups of permissions.",
  "Create a group name, choose the links you want to conceal or reveal.":
    "Create a group name, choose the links you want to conceal or reveal.",
  "Access": "Access",
  "No access": "No access",
  "Show": "Show",
  "Hide": "Hide",
  "Select option": "Select option",
  "List of links": "List of links",
  "List of users": "List of users",
  "Search user": "Search user",
  "GROUP_COMPANY": "Company",
  "GROUP_WORKSPACE": "Workspace",
  "({{count}}) Options": "({{count}}) total",
  "Total Investments": "Total Investments",
  "TOTAL_INVESTMENTS_INFO_TEXT":
    "This section presents the sum of the net values of all investments in each currency. Check the latest updates.",
  "Investments / Institution": "Investments / Bank",
  "Investments / Owner Tag": "Investments / Owner Tag",
  "Investments / Account Tag": "Investments / Account Tag",
  "Investments / Account group": "Investments / Account group",
  "Investments / Owner": "Investments / Owner",
  "INVESTMENTS_INSTITUTION_INFO_TEXT":
    "This chart presents how your investments in each currency are distributed by institution.",
  "INVESTMENTS_GENERAL_OWNER_TAG_INFO_TEXT":
    "This chart presents how your investments in each currency are distributed by owner tag.",
  "INVESTMENTS_ACCOUNT_TAG_INFO_TEXT":
    "This chart presents how your investments in each currency are distributed by account tag.",
  "INVESTMENTS_ACCOUNT_GROUP_INFO_TEXT":
    "This chart presents how your investments in each currency are distributed by account group.",
  "Investments / type": "Investments / type",
  "INVESTMENTS_TYPE_INFO_TEXT":
    "This chart presents how your investments in each currency are distributed by type.",
  "Investments evolution": "Investments evolution",
  "INVESTMENTS_EVOLUTION_INFO_TEXT":
    "This chart presents how the investments (net values) evolve over time. Can apply filters.",
  "Authorized IPs": "Authorized IPs",
  "Add new IP": "Add new IP",
  "Are you sure you want to remove this IP Address?":
    "Are you sure you want to remove this IP Address?",
  "IP Address successfully deleted!": "IP Address successfully deleted!",
  "Add new IP address": "Add new IP address",
  "Add IP address": "Add IP address",
  "IP Address successfully created!": "IP Address successfully created!",
  "Edit IP address": "Edit IP address",
  "Save IP address": "Save IP address",
  "IP Address successfully saved!": "IP Address successfully saved!",
  "Contains information on the position of each investment":
    "Contains information on the position of each investment",
  "Financial Position": "Financial Position",
  "Contains information of your accounts, balances and investments all together":
    "Contains information of your accounts, balances and investments all together",
  "Historical balances": "Historical balances",
  "Balance Evolution": "Balance Evolution",
  "Contains information of historical balances of all the accounts":
    "Contains information of historical balances of all the accounts",
  "Partially registered": "Partially registered",
  "Partially": "Partially",
  "Go to report": "Go to report",
  "Net Position / Institution": "Net Position / Institution",
  "Total Financial Position": "Total Financial Position",
  "Financial Position / Institution": "Financial Position / Institution",
  "Financial Position / Owner Tag": "Financial Position / Owner Tag",
  "Financial Position / Account Tag": "Financial Position / Account Tag",
  "Financial Position / Account group": "Financial Position / Account group",
  "Financial Position / Owner": "Financial Position / Owner",
  "Financial Position / Country": "Financial Position / Country",
  "Financial Evolution": "Financial Evolution",
  "Financial Position / type": "Financial Position / Type",
  "Debits / Category": "Debits per Category",
  "GENERAL_TOTAL_INFO_TEXT":
    "This section presents the sum of the net values of all investments and account balances in each currency. Check the latest updates.",
  "GENERAL_INSTITUTION_INFO_TEXT":
    "This chart presents how the financial position in each currency is distributed by institution.",
  "GENERAL_GENERAL_OWNER_TAG_INFO_TEXT":
    "This chart presents how the financial position in each currency is distributed by owner tag.",
  "GENERAL_ACCOUNT_TAG_INFO_TEXT":
    "This chart presents how the financial position in each currency is distributed by account tag.",
  "GENERAL_ACCOUNT_GROUP_INFO_TEXT":
    "This chart presents how the financial position in each currency is distributed by account group.",
  "GENERAL_COUNTRY_INFO_TEXT":
    "This chart presents how the financial position in each currency is distributed by country.",
  "GENERAL_CREDITS_DEBITS_AND_BALANCE_EVOLUTION_INFO_TEXT":
    "This chart presents how the financial position evolves over time. Can apply filters.",
  "GENERAL_TYPE_INFO_TEXT":
    "This chart presents how the financial position in each currency is distributed by liquidity and investment type.",
  "GENERAL_NET_POSITION_PER_INSTITUTION_INFO_TEXT":
    "This chart presents the sum of inflows and outflows by institution, and the resulting net position. No investments included. Can apply filters.",
  "Total Position": "Total Position",
  "≈ Total Position": "≈ Total Position",
  "Account Balance": "Account Balances",
  "Account balance": "Account balance",
  "is between": "is between",
  "contains": "contains",
  "Value net of taxes and fees, available to rescue.":
    "Value net of taxes and fees, available to rescue.",
  "Blocked balance": "Blocked balance",
  "Judicial blocked balance": "Judicial blocked balance",
  "Overdraft Limit Check": "Overdraft Limit Check",
  "Overdraft Limit": "Overdraft Limit",
  "Taxes Provision": "Taxes Provision",
  "Add new General Owner": "Add new Owners Group",
  "Edit General Owner": "Edit Owners Group",
  "Add General Owner": "Add Owner",
  "Save General Owner": "Save Owners Group",
  "General Owner successfully created!": "Owner successfully created!",
  "General Owner successfully saved!": "Owner successfully saved!",
  "General Owner successfully deleted!": "Owner successfully deleted!",
  "Are you sure you want to remove this General Owner?":
    "Are you sure you want to remove this Owner?",
  "Reassign": "Reassign",
  "Reassign General Owner": "Reassign Owner",
  "General Owner": "Owner Group",
  "General Owners": "Owners Groups",
  "Sync General Owners": "Sync Owners",
  "Sync General Owners successfully!": "Sync Owners successfully!",
  "Links Sync Schedule": "Links Sync Schedule",
  "Execution name": "Execution name",
  "Reassign Owner successfully saved!": "Reassign Owner successfully saved!",
  "Updating": "Updating",
  "Bank Statements": "Bank Statements",
  "Format": "Format",
  "Request Statement": "Request Statement",
  "Bank statement request": "Bank statement request",
  "Request for bank statements received. Check status in downloads menu.":
    "Request for bank statements received. Check status in downloads menu.",
  "Check Downloads": "Check Downloads",
  "Request another statement": "Request another statement",
  "Request Date": "Request Date",
  "requestDate": "Request Date",
  "No results": "No results",
  "NO_ROWS": "No results",
  "Download": "Download",
  "Downloads": "Downloads",
  "New Report": "Generate",
  "Download as ZIP": "Download as ZIP",
  "Download successfully": "Download successfully",
  "You need to reassign owners before the list shows any entries.":
    "You need to reassign owners before the list shows any entries.",
  "Completed": "Completed",
  "COMPLETED": "Completed",
  "Sync Status": "Sync Status",
  "Account Status": "Account Status",
  "Balances Status": "Balances status",
  "Transactions Status": "Transactions status",
  "Investments Status": "Investments status",
  "syncStatus": "Sync Status",
  "accountSyncStatus": "Balances status",
  "trxSyncStatus": "Transactions Status",
  "investmentSyncStatus": "Investments Status",
  "paymentSyncStatus": "Payments Status",
  "invMovementSyncStatus": "Investment Movements Status",
  "paymentReceiptSyncStatus": "Payment receipt Status",
  "paymentSlipSyncStatus": "Payment slip Status",
  "pixTransactionSyncStatus": "Pix Status",
  "Payments Status": "Payments Status",
  "Fail": "Failed",
  "FAIL": "Failed",
  "FAILED": "Failed",
  "Link sync Fail": "Failed",
  "Includes the available balance in checking account and the invested money net of taxes and fees.":
    "Includes the available balance in checking account and the invested money net of taxes and fees.",
  "New Dashboard": "New Dashboard",
  "Dashboards": "Dashboards",
  "Two Factor Authentication": "Two Factor Authentication",
  "Is an additional security level to prevent others from accessing private information. When logging in, you may be asked to input a 6-digit token.":
    "Is an additional security level to prevent others from accessing private information. When logging in, you may be asked to input a 6-digit token.",
  "The next time you log in, you will be prompted to enable Google Authenticator. Occasionally you may be required to provide a 6-digit token.":
    "The next time you log in, you will be prompted to enable Google Authenticator. Occasionally you may be required to provide a 6-digit token.",
  "Are you sure you want to disable Two Factor Authentication?":
    "Are you sure you want to disable Two Factor Authentication?",
  "Confirm": "Confirm",
  "Reset Token": "Reset Token",
  "Token reset successfully!": "Token reset successfully!",
  "Are you sure you want to reset {{userName}}’s Token?":
    "Are you sure you want to reset {{userName}}’s Token?",
  "Set up Google Authenticator": "Set up Google Authenticator",
  "Please install the Google Authenticator app on your device, and then scan the QR code below to set up two-factor authentication (2FA) for the first time.":
    "Please install the Google Authenticator app on your device, and then scan the QR code below to set up two-factor authentication (2FA).",
  "Please insert here the token generated (6 digits).":
    "Please insert here the token generated (6 digits).",
  "Two-factor authentication (2FA)": "Two-factor authentication (2FA)",
  "Assign Permissions": "Assign Permissions",
  "Tag account": "Tag account",
  "Tag successfully deleted!": "Tag successfully deleted!",
  "Add Tag": "Add Tag",
  "View Tag": "View Tag",
  "Tag successfully created!": "Tag successfully created!",
  "Tag successfully saved!": "Tag successfully saved!",
  "Edit Tag": "Edit Tag",
  "Add new Tag": "Add new Tag",
  "Are you sure you want to remove this Tag?":
    "Are you sure you want to remove this Tag?",
  "Tag management": "Tag management",
  "Tag": "Tag",
  "Tags": "Tags",
  "accountTagId": "Account tag",
  "New Account group": "New Account group",
  "Account group successfully created!": "Account group successfully created!",
  "Account group successfully saved!": "Account group successfully saved!",
  "Account group edited successfully!": "Account group edited successfully!",
  "Account group successfully deleted!": "Account group successfully deleted!",
  "Are you sure you want to remove this Account group?":
    "Are you sure you want to remove this Account group?",
  "Account group management": "Account group management",
  "Account group": "Account group",
  "Account group list": "Account group list",
  "accountGroupId": "Account group",
  "Resend mobile verification code": "Forward via mobile",
  "Resend email verification code": "Forward via email",
  "Resend invitation": "Send by SMS",
  "Resend mobile invitation successfully":
    "Successful invitation forwarding via SMS",
  "Share (%)": "Share (%)",
  "Transaction created successfully!": "Transaction created successfully!",
  "Add record": "Add record",
  "Data entry": "Data entry",
  "generalOwnerTagId": "Owner tag",
  "Tag list": "Tag list",
  "Tag owner": "Tag owner",
  "New tag": "New tag",
  "Owner tag": "Owner tag",
  "Account tag": "Account tag",
  "All account tags": "All",
  "Add manually": "Add manually",
  "Are you sure you want to delete this Transaction?":
    "Are you sure you want to delete this Transaction?",
  "Transaction updated successfully!": "Transaction updated successfully!",
  "There are links with automatic refresh schedules; if necessary, add this new link to those rules.":
    "There are links with automatic refresh schedules; if necessary, add this new link to those rules.",
  "Assign Ownership": "Assign Ownership",
  "Ownership": "% Ownership",
  "% Ownership": "% Ownership",
  "Assign Percentage": "Assign Percentage",
  "The percentage must be less than or equal to 100.":
    "The percentage must be less than or equal to 100.",
  "The percentage must be greater than or equal to 0.":
    "The percentage must be greater than or equal to 0.",
  "The value must be greater than or equal to 0.":
    "The value must be greater than or equal to 0.",
  "The value must be less than or equal to {{availableBalance}}.":
    "The value must be less than or equal to {{availableBalance}}.",
  "The value must be greater than 0.": "The value must be greater than 0.",
  "The value must be greater than {{availableBalance}}.":
    "The value must be greater than {{availableBalance}}.",
  "The value must be greater than or equal to {{availableBalance}}.":
    "The value must be greater than or equal to {{availableBalance}}.",
  "The difference must be greater than or equal to {{availableBalance}}.":
    "The difference must be greater than or equal to {{availableBalance}}.",
  "Request now": "Request now",
  "Schedules": "Schedules",
  "New Bank statements schedule": "New schedule",
  "Starts at": "Starts at",
  "Repetition": "Repetition",
  "N° Days": "N° Days",
  "Quick access": "Quick access",
  "Last": "Last",
  "To schedule": "To schedule",
  "When selecting a link, we will request the bank statements of all accounts associated with this link":
    "When selecting a link, we will request the bank statements of all accounts associated with this link",
  "DAY_TYPE_DAYS": "Last {{days}} days",
  "DAY_TYPE_THIS_MONTH": "This month",
  "DAY_TYPE_LAST_MONTH": "Last month",
  "SYNC_LAST_MONTH": "Last month",
  "SYNC_LAST_WEEK": "Last week",
  "SYNC_LAST_BUSINESS_DAY": "Last business day",
  "SYNC_NOW": "Daily information",
  "View schedules": "View schedules",
  "Bank statements schedule successfully!":
    "Bank statements schedule successfully created!",
  "Bank statements schedule successfully saved!":
    "Bank statements schedule successfully saved!",
  "Are you sure you want to remove this Bank statements schedule?":
    "Are you sure you want to remove this Bank statements schedule?",
  "Bank statements schedule successfully deleted!":
    "Bank statements schedule successfully deleted!",
  "Report created successfully!": "Report created successfully!",
  "Report saved successfully!": "Report saved successfully!",
  "Save report": "Save report",
  "Report already exists": "Report already exists",
  "Report deleted successfully!": "Report deleted successfully!",
  "Are you sure you want to remove this Report?":
    "Are you sure you want to remove this Report?",
  "Token was sent to": "Token was sent to",
  "Token expires in 1 minute": "Token expires in 1 minute",
  "The maximum waiting time has elapsed, refresh the page or contact your administrator.":
    "The maximum waiting time has elapsed, refresh the page or contact your administrator.",
  "Minimum and maximum cash": "Minimum and maximum cash",
  "Minimum and maximum cash target": "Minimum and maximum Cash target",
  "Cash target": "Cash target",
  "Cash limits": "Cash limits",
  "Target": "Target",
  "Set minimum and maximum cash limits per currency to optimize the management of your account balances.":
    "Set minimum and/or maximum cash limits per currency to optimize the management of your account balances.",
  "Set minimum and/or maximum cash limits for this specific account.":
    "Set minimum and/or maximum cash limits for this specific account.",
  "Minimum cash": "Minimum cash",
  "Maximum cash": "Maximum cash",
  "Account balance limit deleted successfully!":
    "Cash limit deleted successfully!",
  "Are you sure you want to delete this account balance limit?":
    "Are you sure you want to delete this cash limit?",
  "Account balance limit successfully saved!": "Cash limit successfully saved!",
  "Account balance limit successfully updated!":
    "Cash limit successfully updated!",
  "Surplus": "Surplus",
  "To cover": "To cover",
  "No rules created yet": "No rules created yet",
  "Add all new links to this scheduled refresh.":
    "Add all new links to this scheduled refresh.",
  "All new links will be added to this scheduled refresh.":
    "All new links will be added to this scheduled refresh.",
  "Add \"{{tagName}}\"": "Add \"{{tagName}}\"",
  "Please verify the entered information.":
    "Please verify the entered information.",
  "Please verify the entered credentials.":
    "Please verify the entered credentials.",
  "It was not possible to connect with the Institution.":
    "It was not possible to connect with the Institution.",
  "The user used does not have the required permissions.":
    "The user used does not have the required permissions.",
  "You already have an open session in the Institution. Please close the session and try again.":
    "You already have an open session in the Institution. Please close the session and try again.",
  "Connection not possible. The user used has second-factor authentication.":
    "Connection not possible. The user used has second-factor authentication.",
  "Retry": "Retry",
  "Please try again later": "Please try again later",
  "Institution linked!": "Institution linked!",
  "This institution requires an Master user to accept this registration within the home banking.":
    "This institution requires an Master user to accept this registration within the home banking.",
  "We’re processing the information, this might take a while to reflect on the platform.":
    "We’re processing the information, this might take a while to reflect on the platform.",
  "Meanwhile, please set up the link refresh frequency.":
    "Meanwhile, please set up the link refresh frequency.",
  "There is already a link created with the same credentials.":
    "There is already a link created with the same credentials.",
  "Trust this device for 30 days": "Trust this device for 30 days",
  "Device name": "Device name",
  "Forecast": "Forecast",
  "Executed": "Executed",
  "Cash generated throughout the day.": "Cash generated throughout the day.",
  "Expected": "Expected",
  "Further transactions projected to take place throughout the rest of the day.":
    "Further transactions projected to take place throughout the rest of the day.",
  "Forecasted Balance": "Forecasted Balance",
  "Add transactions": "Add transactions",
  "File name": "File name",
  "Total registers": "Total registers",
  "Registers uploaded": "Registers uploaded",
  "Registers with errors": "Registers with errors",
  "Upload file": "Upload file",
  "Select file": "Select file",
  "Upload": "Upload",
  "File upload try again":
    "There was an error when the file.<br />Please check the file extension or size.<br /><4>Try again</4>.",
  "File successfully upload!": "File successfully upload!",
  "New file": "New file",
  "Download file template": "Download file template",
  "Create a link refresh schedule.": "Create a link refresh schedule.",
  "Existing Link Schedules": "Existing Link Schedules",
  "This link was added to the {{name}} automatic refresh shedule.":
    "This link was added to the {{name}} automatic refresh shedule.",
  "Initial position": "Initial position",
  "End position of the day": "End position of the day",
  "Initial balance": "Initial balance",
  "End balance of the day": "End balance of the day",
  "Cash flow": "Cash flow",
  "label.cashflow": "Cash flow",
  "label.dailyCashflow": "Daily cash flow",
  "label.monthlyCashflow": "Monthly cash flow",
  "Liquid flow": "Cash flow",
  "Accomplished": "Accomplished",
  "Projected": "Projected",
  "INVESTMENT_BALANCE": "Investments",
  "INVESTMENT_BALANCE_END": "Investments (position)",
  "ACCOUNT_BALANCE": "Account balances",
  "OTHERS": "Others",
  "Category group successfully created!":
    "Category group successfully created!",
  "Category group successfully saved!": "Category group successfully saved!",
  "Cashflow targets successfully saved!":
    "Cashflow targets successfully saved!",
  "Cashflow Configuration": "Cashflow Configuration",
  "Consolidated": "Consolidated",
  "Incompleted": "Incompleted",
  "We couldn't sync this Link completely.":
    "We couldn't sync this Link completely.",
  "Link expires in {{time}} minutes": "Link expires in {{time}} minutes",
  "Link expires in {{time}}": "Link expires in {{time}}",
  "Favourite account successfully saved!":
    "Favourite account successfully saved!",
  "Favourite": "Favourite",
  "Open link": "Open link",
  "Daily": "Daily",
  "Download errors": "Download errors",
  "Automatic applications": "Automatic applications",
  "Value From": "Value From",
  "Value To": "Value To",
  "label.applicationTemplate": "Application Template Spreadsheet",
  "label.cvcApplicationTemplate":
    "Application and Withdrawals Template Spreadsheet.",
  "label.rescueTemplate": "Rescue Template Spreadsheet",
  "label.financialPosition": "Financial Position",
  "label.financialPositionByOwner": "Financial Position by Owner",
  "label.financialPositionCustom": "Financial Position (custom)",
  "label.financialPositionExecutive": "Executive Financial Position",
  "label.accounts": "Accounts",
  "label.accountsCustom": "Accounts (custom)",
  "label.accountsGroupCustom": "Financial Position - Account group",
  "label.accountsHistoryCustom": "Accounts - history (custom)",
  "label.customs": "Customs",
  "label.historicalBalances": "Historical Balances",
  "label.accountsForecastBalance": "Balance Evolution",
  "label.positionByBusiness": "Position By Business",
  "label.investments": "Investments",
  "label.investmentsCustom": "Inversiones (custom)",
  "label.investmentsHistoryCustom": "Investments - history (custom)",
  "label.investmentsHistory": "Investments History",
  "label.investmentsMonthly": "Investments Monthly",
  "label.investmentsEvolution": "Investments Evolution",
  "label.investmentMovements": "Investment Movements",
  "label.investmentsByMonth": "Investments by month",
  "label.depositMovement": "CDBs Movements",
  "label.fundMovement": "Fund Movements",
  "label.committedMovement": "Committed Movements",
  "label.automaticApplicationMovement": "Automatic Application Movements",
  "label.automaticApplicationMonthlyBalances":
    "Automatic Application Monthly Balances",
  "label.transactions": "Transactions",
  "label.transactionNotImpactCashflow":
    "Transactions that do not impact the cash flow",
  "label.transactionsPaymentsNotImpactCashflow":
    "Payments that do not impact the cash flow",
  "label.transactionsCategories": "Transactions with Categories",
  "label.transactionsByAccount": "Transactions by Account",
  "label.transactionsByAccountLastDay": "Transactions By Account Closing Day",
  "label.transactionsManualByAccount": "Transactions Expected by Account",
  "label.transactionsDailyPaymentConference": "Daily Payment Conference",
  "label.transactionsPayments": "Payments",
  "label.transactionsCategoriesFees": "Fees Per Month",
  "label.transactionsIntraCompany":
    "Transfers between accounts of the same holder",
  "label.transactionsFeesDaily": "Daily fees",
  "label.weeklyPositionBalances": "Weekly Position Balances",
  "label.favourite": "Favourite",
  "label.cashFlowByCompany": "Cash Flow by Company",
  "label.positionByCompany": "Position by Company",
  "label.accountsConsolidatedOwner": "Consolidated View by Owner",
  "label.accountsBlockedBalanceEvolution": "Evolution of blocked balances",
  "label.accountsBlockedJudicialBalanceEvolution":
    "Evolution of judicial blocks",
  "label.dailyBalanceOfApplicationsByInstitution":
    "Daily balance of applications By Institution",
  "label.dailyApplicationBalancePerOwner":
    "Daily application balance per owner",
  "Historical evolution of blocked balances per account.":
    "Historical evolution of blocked balances per account.",
  "Historical evolution of judicially blocked balances, by account.":
    "Historical evolution of judicially blocked balances, by account.",
  "Consolidated balances and investments from the previous day, grouped by account and owner tags.":
    "Consolidated balances and investments from the previous day, grouped by account and owner tags.",
  "Surplus balances and balances to be covered, grouped by Owner":
    "Surplus balances and balances to be covered, grouped by Owner",
  "Current cash position per account.": "Current cash position per account.",
  "Current balances per account.": "Current balances per account.",
  "Historical evolution of balances per account.":
    "Historical evolution of balances per account.",
  "Historical evolution of checking account and investment balances.":
    "Historical evolution of checking account and investment balances.",
  "Daily balance of applications (by Institution)":
    "Daily balance of applications (by Institution)",
  "Daily balance of applications (by Owner)":
    "Daily balance of applications (by Owner)",
  "Cash flow by company.": "Cash flow by company.",
  "Cash position projection for the day.":
    "Cash position projection for the day.",
  "Current investment position per account.":
    "Current investment position per account.",
  "Historical evolution of investments per account.":
    "Historical evolution of investments per account.",
  "Monthly position of each investment.":
    "Monthly position of each investment.",
  "Transaction details for a date range.":
    "Transaction details for a date range.",
  "Transaction details with the categories included.":
    "Transaction details with the categories included.",
  "Applications and withdraws for a date range.":
    "Applications and withdraws for a date range.",
  "Current invested position per application.":
    "Current invested position per application.",
  "Historical invested position per application.":
    "Historical invested position per application.",
  "Position by application, sorted by oldest application date and lowest remuneration.":
    "Position by application, sorted by oldest application date and lowest salary.",
  "The platform will connect with Open Finance":
    "The platform will connect with <strong>{{ name }}</strong> through Open Finance connections to obtain a complete financial overview.",
  "By pressing “Continue”, you confirm acceptance of the Terms and Conditions.":
    "By pressing “Continue”, you accept the <2>Terms and Conditions</2>.",
  "Iniciador is our partner for financial data connection and data sharing. Through Iniciador, you can securely provide us with your data, and you also have the possibility to control and revoke this access at any time.":
    "Iniciador is our partner for financial data connection and data sharing. Through Iniciador, you can securely provide us with your data, and you also have the possibility to control and revoke this access at any time.",
  "Iniciador is an institution authorized and regulated by the Central Bank of Brazil, a certified participant of Pix framework and Open Finance Brasil, registered under CNPJ 44.471.172/0001-19.":
    "Iniciador is an institution authorized and regulated by the Central Bank of Brazil, a certified participant of Pix framework and Open Finance Brasil, registered under CNPJ 44.471.172/0001-19.",
  "Check the terms and conditions.": "Check the terms and conditions.",
  "Terms and conditions": "Terms and conditions",
  "Learn more about data and deadlines": "Learn more about data and deadlines",
  "Data and deadlines": "Data and deadlines",
  "The data that will be shared by your Bank are:":
    "The data that will be shared by your Bank are:",
  "Account data": "Account data",
  "1. Identification": "Identification",
  "1. Balances": "Balances",
  "2. Limits": "Limits",
  "3. Transactions": "Transactions",
  "Registration data": "Registration data",
  "Frequently asked questions": "Frequently asked questions",
  "How is the sharing done?": "How is the sharing done?",
  "Data sharing is carried out through Iniciador, an institution authorized by the Central Bank of Brazil to connect with other institutions via Open Finance:":
    "Data sharing is carried out through Iniciador, an institution authorized by the Central Bank of Brazil to connect with other institutions via Open Finance:",
  "Share your account data with Iniciador":
    "Share your account data with Iniciador",
  "Through Open Finance, Iniciador collects the banking data you allow and prepares it for secure sharing with us.":
    "Through <strong>Open Finance</strong>, Iniciador collects the banking data you allow and prepares it for secure sharing with us.",
  "You authorize Iniciador to share with us the account data you are connecting":
    "You authorize Iniciador to share with us the account data you are connecting",
  "Iniciador acts as your intermediary, allowing only the sharing with us of the data you authorize, protected by the General Data Protection Law.":
    "Iniciador acts as your intermediary, allowing only the sharing with us of the data you authorize, protected by the <strong>General Data Protection Law</strong>.",
  "What is Open Finance?": "What is Open Finance?",
  "Open Finance is the evolution of Open Banking. It refers to the ability of customers of financial products and services to allow the sharing of their information among different institutions authorized by the Central Bank and the movement of their bank accounts from various platforms, not just through the bank's app or website, in a secure, efficient, and convenient manner.":
    "Open Finance is the evolution of Open Banking. It refers to the ability of customers of financial products and services to allow the sharing of their information among different institutions authorized by the Central Bank and the movement of their bank accounts from various platforms, not just through the bank's app or website, in a secure, efficient, and convenient manner.",
  "Who is Iniciador?": "Who is Iniciador?",
  "Iniciador is our partner for financial data connection and sharing. Through Iniciador, you can securely provide us with your data, and you also have the ability to control and revoke this access at any time.":
    "Iniciador is our partner for financial data connection and sharing. Through Iniciador, you can securely provide us with your data, and you also have the ability to control and revoke this access at any time.",
  "Iniciador is an institution authorized and regulated by the Central Bank of Brazil, an approved participant of the Pix Arrangement and Open Finance Brazil, registered under CNPJ 44.471.172/0001-19.":
    "Iniciador is an institution authorized and regulated by the Central Bank of Brazil, an approved participant of the Pix Arrangement and Open Finance Brazil, registered under CNPJ 44.471.172/0001-19.",
  "How can I manage my shared data?": "How can I manage my shared data?",
  "At any time, you can modify, renew, or cancel your data sharing through the Open Finance Management panel available in the main menu of this application or through the link: portal.iniciador.com.br.":
    "At any time, you can modify, renew, or cancel your data sharing through the Open Finance Management panel available in the main menu of this application or through the link: <2>portal.iniciador.com.br</2>.",
  "Preparing the open finance connection":
    "Preparing the open finance connection",
  "Summary of the sharing": "Summary of the sharing",
  "Redirecting to {{name}} in {{count}}":
    "Redirecting to {{name}} in {{count}}",
  "Open Finance Management": "Open Finance Management",
  "It could contain both checking account balances and automatic applications.":
    "It could contain both checking account balances and automatic applications.",
  "Available Cash Position": "Total position",
  "Includes the Available Balance + Automatic Applications and Investments Net Value.":
    "Includes the Available Balance + Automatic Applications and Investments Net Value.",
  "Add cash account": "Add cash account",
  "Write to create one": "Write to create one",
  "Owner successfully created!": "Owner successfully created!",
  "Cash Holding account successfully created!":
    "Cash Holding account successfully created!",
  "Cash Holding account successfully saved!":
    "Cash Holding account successfully saved!",
  "CASH": "Cash",
  "CASH_HOLDING": "Cash Holding",
  "Cash Holding": "Cash Holding",
  "The account has an overdraft limit of {{value}}":
    "The account has an overdraft limit of {{value}}",
  "lbl_full_account_number_ag": "Agency",
  "Agency": "Agency",
  "lbl_full_account_number_conta": "Account",
  "lbl_full_account_number_dv": "DV",
  "digitCount_one": "{{count}} digit",
  "digitCount_other": "{{count}} digits",
  "maxDigitCount_one": "Max. {{count}} digit",
  "maxDigitCount_other": "Max. {{count}} digits",
  "Schedule successfully deleted!": "Schedule successfully deleted!",
  "Schedule successfully created!": "Schedule successfully created!",
  "Withdrawal criteria": "Withdrawal criteria",
  "Configuration": "Configuration",
  "Parameters": "Parameters",
  "Create a schedule": "Create a schedule",
  "View schedule": "View schedule",
  "Edit schedule": "Edit schedule",
  "Delete schedule": "Delete schedule",
  "Are you sure you want to delete this Report schedule?":
    "Are you sure you want to delete this Report schedule?",
  "User unlocked successfully!": "User unlocked successfully!",
  "Unlock": "Unlock",
  "Lock": "Lock",
  "Are you sure you want to delete the {{name}} workspace?":
    "Are you sure you want to delete the {{name}} workspace?",
  "Performing this action will delete all the links that belong to the workspace and all the information related.":
    "Performing this action will delete all the links that belong to the workspace and all the information related.",
  "To confirm the deletion, type the name of the workspace into the field.":
    "To confirm the deletion, type the name of the workspace into the field.",
  "Export to PDF": "Export to PDF",
  "Overview config successfully saved!": "Configuration successfully saved!",
  "Configuration successfully saved!": "Configuration successfully saved!",
  "Overview Config": "Configuration",
  "Total blocked balance": "Total blocked balance",
  "Idle balance": "Idle balance",
  "Balance in accounts": "Idle cash",
  "Balance in investments": "Investments",
  "Accounts with surplus": "Accounts with surplus",
  "Accounts to cover": "Accounts to cover",
  "Negative accounts": "Negative accounts",
  "Deleted": "Deleted",
  "This account was deleted by the institution.":
    "This account was deleted by the institution.",
  "Net investment": "Net investment",
  "This is an estimated value.": "This is a calculated value.",
  "Weekly": "Weekly",
  "You have a total of {{currency}} {{todayAmount}} in investments that expires today.":
    "You have a total of {{currency}} {{todayAmount}} in investments that expires today.",
  "You have a total of {{currency}} {{tomorrowAmount}} in investments that expires tomorrow.":
    "You have a total of {{currency}} {{tomorrowAmount}} in investments that expires tomorrow.",
  "You have a total of {{currency}} {{todayAmount}} in investments that expires today. You have a total of {{currency}} {{tomorrowAmount}} in investments that expires tomorrow.":
    "You have a total of {{currency}} {{todayAmount}} in investments that expires today. You have a total of {{currency}} {{tomorrowAmount}} in investments that expires tomorrow.",
  "You have a total of {{currency}} {{amount}} in investments that expires today.":
    "You have a total of {{currency}} {{amount}} in investments that expires today.",
  "You have a total of {{currency}} {{amount}} in investments that expires on {{dueDate}}.":
    "You have a total of {{currency}} {{amount}} in investments that expires on {{dueDate}}.",
  "You have a total of {{currency}} {{amount}} in Deposits that expire today.":
    "You have a total of {{currency}} {{amount}} in CDBs that expire today.",
  "You have a total of {{currency}} {{amount}} in COE that expire today.":
    "You have a total of {{currency}} {{amount}} in COE that expire today.",
  "You have a total of {{currency}} {{amount}} in Committed investments that expire today.":
    "You have a total of {{currency}} {{amount}} in Committed investments that expire today.",
  "See here": "See here",
  "Future cash": "Future cash",
  "GENERAL_FUTURE_CASH_INFO_TEXT":
    "This chart presents today’s upcoming credits, debits and Investments expirations, and in the next 6 days.",
  "Investments expiration": "Investments expiration",
  "There are no investments expiring in the selected period.":
    "There are no investments expiring in the selected period.",
  "There are no future credits or debits reported for the selected period.":
    "There are no future credits or debits reported for the selected period.",
  "Committed Applications": "Committed Applications",
  "Committed": "Committed",
  "committed": "Committed",
  "Deposit Applications": "CDBs Applications",
  "COMMITTED_APPLICATIONS": "Committed withdraw",
  "committedWithdrawName": "Committed to expire",
  "DEPOSIT_APPLICATIONS": "CDBs withdraw",
  "depositWithdrawName": "CDBs to expire",
  "Deposit": "Fixed income",
  "Fund Applications": "Fund Applications",
  "Fund": "Fund",
  "Indexer": "Relative performance",
  "PERFORMANCE": "Investments (returns)",
  "Remaining main balance": "Remaining main balance",
  "Quota balance": "Quota balance",
  "Quota quantity": "Quota quantity",
  "Quota gross price value": "Quota gross price value",
  "Financial Efficiency": "Financial Efficiency",
  "GENERAL_EFFICIENCY_INFO_TEXT":
    "This chart presents the financial efficiency of the cash position both daily and monthly, by calculating the daily average of each month.",
  "Efficiency": "Efficiency",
  "Efficiency (%)": "Efficiency (%)",
  "Investments net value": "Investments net value",
  "label.accountingTransactions": "Accounting Transactions",
  "Partial errors": "Partial errors",
  "We are experiencing some connection instability with {{description}}.":
    "We are experiencing some connection instability with <strong>{{description}}</strong>.",
  "Please check out the last update. We are sorry for the inconvenience.":
    "Please check out the <2>last update</2>. We are sorry for the inconvenience.",
  "label.investmentApplications": "Applications",
  "label.investmentsAppDeposit": "Fixed income",
  "label.investmentsAppDepositCustom": "Fixed income (custom)",
  "label.investmentsAppCommitted": "Committed",
  "label.investmentsAppCommittedCustom": "Committed (custom)",
  "label.investmentsAppFund": "Fund",
  "label.depositApplicationHistory": "CDBs Application History",
  "label.committedApplicationHistory": "Committed Application History",
  "label.fundApplicationHistory": "Fund Application History",
  "Help": "Help",
  "To omit": "Omit",
  "Finish": "Finish",
  "Future Transactions": "Future Transactions",
  "To be able to forecast balances, we need you to upload information on future credits and debits. Options: manually, by file, and via APIs.":
    "To be able to forecast balances, we need you to upload information on future credits and debits. Options: manually, by file, and via APIs.",
  "Categorize your historical and future movements, based on your internal classification.":
    "Categorize your historical and future movements, based on your internal classification.",
  "Targets": "Targets",
  "Double click and incorporate targets to automatically verify their fulfillment.":
    "Double click and incorporate targets to automatically verify their fulfillment.",
  "Once the targets are incorporated, click on “Save”.":
    "Once the targets are incorporated, click on “Save”.",
  "Tax on Financial Operations (IOF) is a tax that focuses on the income of financial investments and occurs in the redemptions made within 30 days of the date of application. See detail.":
    "Tax on Financial Operations (IOF) is a tax that focuses on the income of financial investments and occurs in the redemptions made within 30 days of the date of application.<br/><br/><3>See detail</3>",
  "Income tax is a tax that focuses on the net income of financial investments decreasing over time. See detail.":
    "Income tax is a tax that focuses on the net income of financial investments decreasing over time.<br/><br/><3>See detail</3>",
  "Projected balance in investments": "Projected balance in investments",
  "Projected balance in current accounts":
    "Projected balance in current accounts",
  "forecastDate": "Date",
  "label.historicalAutomaticApplications": "Historical Automatic Applications",
  "Are you sure you want to delete this category group?":
    "Are you sure you want to delete this category group? Any categories associated with this group will be moved to the \"Others\" group.",
  "Close Panel": "Close Panel",
  "Open Panel": "Open Panel",
  "indicatorType": "Indicator",
  "Indicator": "Indicator",
  "SHORTAGE": "Accounts to cover",
  "OVERAGE": "Accounts with surplus",
  "NEGATIVE": "Negative accounts",
  "label.accountsBalanceEvolution": "Balance Evolution",
  "label.forcastedCashPosition": "Forecasted Cash Position",
  "Active filters": "Active filters",
  "One-time Password": "One-time Password",
  "Disabled by the company": "Disabled by the company",
  "Provide a one-time password using Google Authenticator or similar.":
    "Provide a one-time password using Google Authenticator or similar.",
  "One-time password enabled succefully!":
    "One-time password enabled succefully!",
  "One-time password disabled succefully!":
    "One-time password disabled succefully!",
  "Optimize": "Optimize",
  "Criteria": "Criteria",
  "Manage Criteria": "Manage Criteria",
  "What are the withdrawal criteria?": "What are the withdrawal criteria?",
  "What is the amount you want to withdraw?":
    "What is the amount you want to withdraw?",
  "Amount to withdraw": "Amount to withdraw",
  "Total amount to withdraw": "Total amount to withdraw",
  "For which owners do you need to withdraw?":
    "For which owners do you need to withdraw?",
  "From which institutions do you need to withdraw?":
    "From which institutions do you need to withdraw?",
  "From which accounts do you need to withdraw?":
    "From which accounts do you need to withdraw?",
  "Are you sure you want to remove this Criteria?":
    "Are you sure you want to remove this Criteria?",
  "Criteria successfully deleted!": "Criteria successfully deleted!",
  "Criteria successfully created!": "Criteria successfully created!",
  "Criteria successfully saved!": "Criteria successfully saved!",
  "New": "New",
  "Lower tax amount": "Lower tax amount",
  "Less remuneration": "Lower return",
  "Lower profitability": "Lower profit",
  "Lower tax rates": "Lower tax rates",
  "Withdraw Finish": "Finish",
  "Withdraw Reset": "Reset",
  "Closer to the expiration date": "Closer to the expiration date",
  "Applications about to expire": "Expiration calendar",
  "{{count}} Applications_one": "{{count}} Application",
  "{{count}} Applications_other": "{{count}} Applications",
  "You don’t have investments about to expire.":
    "You don’t have investments about to expire.",
  "Impact Cash flow": "Impact Cash flow",
  "label.accountsWeeklyPosition": "Weekly position",
  "negative balances": "negative balances",
  "balances to cover": "balances to cover",
  "surplus in balances": "surplus in balances",
  "Application type": "Application type",
  "Sync accounts: {{totalAccountProcessed}}/{{total}}":
    "Balances: {{totalAccountProcessed}} of {{total}} accounts",
  "Sync account transactions: {{totalTrxProcessed}}/{{total}}":
    "Transactions: {{totalTrxProcessed}} of {{total}} accounts",
  "Sync account investments: {{totalInvestmentProcessed}}/{{total}}":
    "Investments: {{totalInvestmentProcessed}} of {{total}} accounts",
  "Sync account payments: {{totalPaymentProcessed}}/{{total}}":
    "Payments: {{totalPaymentProcessed}} of {{total}} accounts",
  "Sync account investment movements: {{totalInvMovementProcessed}}/{{total}}":
    "Movements: {{totalInvMovementProcessed}} of {{total}} accounts",
  "Sync account pix: {{totalPixTransactionProcessed}}/{{total}}":
    "Pix: {{totalPixTransactionProcessed}} of {{total}} accounts",
  "Sync account payment receipts: {{totalPaymentReceiptProcessed}}/{{total}}":
    "Payment Receipts: {{totalPaymentReceiptProcessed}} of {{total}} accounts",
  "There are no investments expiring within this date range.":
    "There are no investments expiring within this date range.",
  "Schedule report": "Schedule",
  "Program": "Program",
  "Report schedules": "Schedules",
  "View Report schedules": "View schedules",
  "LAST_DAY": "Yesterday",
  "LAST_WORKING_DAY": "Last working day",
  "Working days": "Working days",
  "Working days applied": "Working days applied",
  "CURRENT_DAY": "Current day",
  "LAST_WEEK": "Last 7 days",
  "LAST_15_DAYS": "Last 15 days",
  "LAST_30_DAYS": "Last 30 days",
  "LAST_MONTH": "Last month",
  "CURRENT_MONTH": "Current month",
  "Month": "Month",
  "INSTITUTION_STATUS_ONLINE": "Stable connection",
  "INSTITUTION_STATUS_OFFLINE": "Unstable connection",
  "INSTITUTION_STATUS_UNSTABLE": "Unstable connection",
  "Status of all Institutions": "Status of all Institutions",
  "Institutions status": "Institutions status",
  "CASH_FORECASTING": "Cash forecasting",
  "Batch payments": "Batch payments",
  "Batch number": "Batch number",
  "batch": "Batch number",
  "PAYMENT_STATUS_NOT_EXECUTED": "Not executed",
  "PIX_STATUS_EXECUTED": "Executed",
  "PAYMENT_STATUS_EXECUTED": "Executed",
  "PAYMENT_STATUS_PARTIALLY_AUTHORIZED": "Partially authorized",
  "PAYMENT_STATUS_AUTHORIZED": "Authorized",
  "PAYMENT_STATUS_PENDING_EXECUTION": "Pending execution",
  "PAYMENT_STATUS_UNKNOWN": "Unknown",
  "PAYMENT_STATUS_SCHEDULED": "Scheduled",
  "PAYMENT_STATUS_BLOCKED": "Blocked",
  "PAYMENT_STATUS_CANCELED": "Canceled",
  "PAYMENT_STATUS_REFUNDED": "Refunded",
  "PAYMENT_STATUS_REJECTED": "Rejected",
  "PAYMENT_STATUS_PENDING_AUTHORIZATION": "Pending authorization",
  "DOWNLOADABLE_STATUS_PENDING": "Pending",
  "DOWNLOADABLE_STATUS_REQUESTED": "Requested",
  "DOWNLOADABLE_STATUS_IN_PROGRESS": "In progress",
  "DOWNLOADABLE_STATUS_FAILED": "Failed",
  "DOWNLOADABLE_STATUS_PROCESSED": "Processed",
  "downloadable": "Payment receipt",
  "The link to your report has expired.":
    "The link to your report has expired.",
  "Login to the platform to generate a new report.":
    "Login to the platform to generate a new report.",
  "Unsupported file": "Unsupported file",
  "Custom": "Custom",
  "Has report schedules": "{{count}} Schedules",
  "Select owner": "Select owner",
  "Generated on": "Generated on",
  "Favourite report": "Favourite report",
  "The report will be saved according to the previously activated filters.":
    "The report will be saved according to the previously activated filters.",
  "View Reports": "View Reports",
  "The report will be sent according to the previously activated filters.":
    "The report will be sent according to the previously activated filters.",
  "Are you sure you want to remove this report from your favourites?":
    "Are you sure you want to remove this report from your favourites?",
  "Favourite report successfully created!":
    "Favourite report successfully created!",
  "Favourite report successfully edited!":
    "Favourite report successfully edited!",
  "View successfully edited!": "View successfully edited!",
  "View successfully created!": "View successfully created!",
  "Favourite report successfully deleted!":
    "Favourite report successfully deleted!",
  "Mark report as favourite": "Mark report as favourite",
  "Edit favourite report": "Edit favourite report",
  "Execute": "Execute",
  "Password Policy": "Password Policy",
  "Password Policy updated succefully!": "Password Policy updated succefully!",
  "Datanomik Standard": "Datanomik Standard",
  "Customized": "Customized",
  "Minimum characters": "Minimum characters",
  "characters": "characters",
  "Password creation requirements:": "Password creation requirements:",
  "minimum uppercase character (A-Z)": "minimum uppercase character (A-Z)",
  "minimum lowercase character (A-Z)": "minimum lowercase character (A-Z)",
  "minimum number (0-9)": "minimum number (0-9)",
  "minimum special symbol (*!%#$)": "minimum special symbol (*!%#$)",
  "Other requirements:": "Other requirements:",
  "Request the password exchange for each":
    "Request the password exchange for each",
  "days": "days",
  "Login attempt": "Login attempt",
  "attempts": "attempts",
  "After the number of login attempts, the user will be blocked.":
    "After the number of login attempts, the user will be blocked.",
  "Inactivity on the platform": "Inactivity on the platform",
  "Maximum inactivity time before blocking use:":
    "Maximum inactivity time before blocking use:",
  "After the days scheduled without access to the platform, the user must again request access to the administrator":
    "After the days scheduled without access to the platform, the user must again request access to the administrator",
  "Wrong minimun value": "Wrong minimun value",
  "Minimum value is 0": "Minimum value is 0",
  "Resend": "Resend",
  "Report successfully resended!": "Report successfully resended!",
  "Transaction By Account": "Transactions by Account",
  "Accounting Transactions": "Accounting Transactions",
  "Transaction by Account with Closing Day":
    "Transactions By Account Closing Day",
  "Group of categories": "Group of categories",
  "Edit group": "Edit group",
  "Edit category": "Edit category",
  "Add group": "Add group",
  "Login logs": "Activity logs",
  "Log user": "User",
  "Login Date": "Login",
  "Logout Date": "Logout",
  "Activity log history": "Activity history",
  "Session ID": "Session ID",
  "Session": "Session",
  "Strategic": "Strategic",
  "Strategic Treasury": "Strategic Treasury",
  "Analytical Treasury": "Analytical Treasury",
  "Smart Cash Pilot": "Smart Cash Pilot",
  "Low performance": "Low performance",
  "Efficiency Score": "Efficiency Score",
  "Portfolio Performance": "Portfolio remuneration",
  "PERFECT!": "Perfect!",
  "HIGH": "High",
  "MEDIUM": "Medium",
  "LOW": "Low",
  "Represents the percentage of invested cash.":
    "Represents the percentage of invested cash.",
  "This section shows the sum of the net values of all investments, current balances and automatic applications.":
    "This section shows the sum of the net values of all investments, current balances and automatic applications.",
  "Represents the percentage of remuneration of fixed-income investments.":
    "Represents the percentage of remuneration of fixed-income investments.",
  "This graph displays the invested cash position by type of investment.":
    "This graph displays the invested cash position by type of investment.",
  "This graph displays investments to expire within a range of future dates.":
    "This graph displays investments to expire within a range of future dates.",
  "This graph displays the daily evolution of credits and debits within a future date range.":
    "This graph displays the daily evolution of credits and debits within a future date range.",
  "Future Cash": "Future Cash",
  "Account status": "Account status",
  "This section presents the status of the accounts with respect to balances and automatic applications, compared to the established cash limits.":
    "This section presents the status of the accounts with respect to balances and automatic applications, compared to the established cash limits.",
  "Potential of gain in the remuneration account {{currency}} {{value}}":
    "Potential of gain in the remuneration account {{currency}} {{value}}",
  "Accounts ({{count}})": "Accounts ({{count}})",
  "Enable recurrence": "Enable recurrence",
  "We will send every {{periodDay}} at {{periodTime}}h.":
    "We will send every {{periodDay}} at {{periodTime}}h.",
  "{{periodDay}} at {{periodTime}}h.": "{{periodDay}} at {{periodTime}}h.",
  "at {{periodTime}}h.": "at {{periodTime}}h.",
  "MONDAY": "Monday",
  "TUESDAY": "Tuesday",
  "WEDNESDAY": "Wednesday",
  "THURSDAY": "Thursday",
  "FRIDAY": "Friday",
  "Weekly days": "Weekly days",
  "Best rescue option": "Best rescue option",
  "Exit fullscreen": "Exit fullscreen",
  "Fullscreen": "Fullscreen",
  "Analytic": "Analytic",
  "UNCATEGORIZED": "Uncategorized",
  "TYPE_BATCH": "SISPAG",
  "TYPE_PIX": "PIX",
  "TYPE_TICKET": "TICKET",
  "TYPE_SERVICE": "SERVICE",
  "TYPE_TED": "TED",
  "TYPE_DOC": "DOC",
  "TYPE_OTHER": "OTHER",
  "Select view": "Select view",
  "View list": "View list",
  "The view will be created based on the previously applied filters.":
    "The view will be created based on the previously applied filters.",
  "New view": "New view",
  "Edit view": "Edit view",
  "View management": "View management",
  "View successfully saved!": "View successfully saved!",
  "Are you sure you want to remove this View?":
    "Are you sure you want to remove this View?",
  "View successfully deleted!": "View successfully deleted!",
  "Consolidated view of balances": "Consolidated view of balances",
  "net surplus": "net surplus",
  "Remaining balance to cover": "Remaining balance to cover",
  "{{count}} days_one": "{{count}} day",
  "{{count}} days_other": "{{count}} days",
  "New simulation": "New simulation",
  "Simulation": "Simulation",
  "Investment simulation": "Investment simulation",
  "Calculate": "Calculate",
  "Perform new simulation": "New simulation",
  "Value to be invested": "Value to be invested",
  "Investment option": "Investment option",
  "Above 30 days the best option would be CDB.":
    "Above 30 days the best option would be CDB.",
  "For a term of less than 30 days, the best option is a Committed.":
    "For a term of less than 30 days, the best option is a Committed.",
  "Remuneration (% of DI)": "Remuneration (% of DI)",
  "DI Rate (%)": "DI Rate (%)",
  "IOF tax (%)": "IOF tax (%)",
  "IR tax (%)": "IR tax (%)",
  "Expected investment value": "Expected investment value",
  "Term": "Days",
  "Potential financial gain (net)": "Potential financial gain (net)",
  "DI Rate": "DI Rate",
  "Gross gain": "Gross gain",
  "IOF tax": "IOF tax",
  "IR tax": "IR tax",
  "Net gain": "Net gain",
  "Net profitability": "Net profitability",
  "Deadline days": "Days",
  "Expiration date": "Expiration date",
  "Some links were not fully updated or they have not been updated since yesterday, affecting the information available on the platform. Please try to synchronize them again.":
    "Some links were not fully updated or they have not been updated since yesterday, affecting the information available on the platform. Please try to synchronize them again.",
  "Synchronize now": "Synchronize now",
  "Are you sure you want to synchronize them again?":
    "Are you sure you want to synchronize them again?",
  "Transaction value": "Transaction value",
  "Union": "Union",
  "Intersection": "Intersection",
  "Double click to edit": "Double click to edit",
  "Workspace user status": "Workspace status",
  "Total categories amount must match with":
    "Total categories amount must match with",
  "DEFAULT": "Default",
  "View": "View",
  "Views": "Views",
  "Payments to suppliers": "Payments to suppliers",
  "Optimization": "Optimization",
  "Cash flow evolution": "Cash flow evolution",
  "Withdrawals": "Withdrawals",
  "Liquidity index": "Liquidity index",
  "This graph shows how the cash flow evolves, separating the information between working capital and the evolution of investments and withdrawals. The Liquidity Index provides insight into the ability to meet short-term financial obligations and manage cash flow effectively.":
    "This graph shows how the cash flow evolves, separating the information between working capital and the evolution of investments and withdrawals. The Liquidity Index provides insight into the ability to meet short-term financial obligations and manage cash flow effectively.",
  "Depending on the availability of the Banks, statements may be available up to the 5th business day.":
    "Depending on the availability of the Banks, statements may be available up to the 5th business day.",
  "Download type": "Download type",
  "FILE_LIST_DOWNLOAD_TYPE_DEFAULT": "Default",
  "FILE_LIST_DOWNLOAD_TYPE_NONE": "Ungrouped",
  "FILE_LIST_DOWNLOAD_TYPE_OWNER": "Grouped by owner",
  "Consolidated view by Owner": "Consolidated view by Owner",
  "Surplus balance": "Surplus balance",
  "Balance to cover": "Balance to cover",
  "Negative balance": "Negative balance",
  "Consolidated balance": "Consolidated balance",
  "Consolidated value": "Consolidated value",
  "Withdraw": "Withdraw",
  "View all applications": "View all applications",
  "Insufficient investment position to cover the accounts of this owner.":
    "Insufficient investment position to cover the accounts of this owner.",
  "Transaction Type": "Transaction Type",
  "Add view": "Add view",
  "Personalize the dashboard visualization, identify trends, and make strategic decisions based on accurate and up-to-date information.":
    "Personalize the dashboard visualization, identify trends, and make strategic decisions based on accurate and up-to-date information.",
  "Give a name to this visualization": "Give a name to this visualization",
  "Choose the criteria for visualization":
    "Choose the criteria for visualization",
  "The defined criteria will be the basis for the platform's visualization.":
    "The defined criteria will be the basis for the platform's visualization.",
  "Choose the users who will have access to this visualization":
    "Choose the users who will have access to this visualization",
  "The users will have \"Read-only\" permissions to access this visualization.":
    "The users will have \"Read-only\" permissions to access this visualization.",
  "You can create a custom criterias to sort the applications.":
    "You can create a custom criterias to sort the applications.",
  "Portfolio performance": "Portfolio performance",
  "Portfolio": "Portfolio",
  "Loss": "Loss",
  "GENERAL_PORTFOLIO_PERFORMANCE_INFO_TEXT":
    "This graph presents the monthly evolution of the investment portfolio performance, compared to the DI rate and inflation for each month.",
  "Remember to configure the following email to send the statements to be processed automatically:":
    "Remember to configure the following email to send the statements to be processed automatically:",
  "Enter the decryption key for the email.":
    "Enter the decryption key for the email.",
  "You have \"Manual\" and/or \"Open Finance\" links that have not been updated yet. Please remember that they need to be updated manually.":
    "You have \"Manual\" and/or \"Open Finance\" links that have not been updated yet. Please remember that they need to be updated manually.",
  "Additionally, please remember that the \"Manual\" and \"Open Finance\" links need to be updated manually.":
    "Additionally, please remember that the \"Manual\" and \"Open Finance\" links need to be updated manually.",
  "Expiration detail": "Expiration detail",
  "External id": "External id",
  "My views": "My views",
  "Please note that the account list will be updated. This may involve adding new accounts and removing those that no longer exist in the Institution.":
    "Please note that the account list will be updated. This may involve adding new accounts and removing those that no longer exist in the Institution.",
  "Do you agree to continue?": "Do you agree to continue?",
  "Connecting Accounts": "Connecting Accounts",
  "Welcome to the new era of Intelligent Treasury":
    "Welcome to the new era of <2>Intelligent Treasury</2>",
  "Understand your company's cash flow and make strategic decisions.":
    "Understand your company's cash flow and make strategic decisions.",
  "Start now": "Start now",
  "Defining Company Profile": "Defining Company Profile",
  "Cash Opening and Closing": "Cash Opening and Closing",
  "This information will define the update time of links.":
    "This information will define the update time of links.",
  "Choose the cash opening hours": "Choose the cash opening hours",
  "hour": "hour",
  "Choose the cash closing time": "Choose the cash closing time",
  "Cash Management Limits and Goals": "Cash Management Limits and Goals",
  "Minimum cash limit": "Minimum cash limit",
  "Maximum cash limit": "Maximum cash limit",
  "Financial efficiency goal": "Financial efficiency goal",
  "Portfolio performance target": "Portfolio performance target",
  "(fixed income)": "(fixed income)",
  "Let's start?": "Let's start?",
  "To connect": "To connect",
  "Attention": "Attention",
  "During the registration period of the links, we ask you not to access the internet banking until our dashboard is updated. This will ensure the safety and integrity of your information. Thank you for understanding!":
    "During the registration period of the links, we ask you not to access the internet banking until our dashboard is updated. This will ensure the safety and integrity of your information. Thank you for understanding!",
  "Invite users to use the platform": "Invite users to use the platform",
  "Synchronizing": "Synchronizing",
  "Company settings successfully saved!":
    "Company settings successfully saved!",
  "Efficiency Analysis: {{mondayLastWeek}} - {{fridayLastWeek}}":
    "<0>Efficiency Analysis:</0> {{mondayLastWeek}} - {{fridayLastWeek}}",
  "Efficiency Analysis": "Efficiency Analysis",
  "Period: {{mondayLastWeek}} - {{fridayLastWeek}}":
    "Period: {{mondayLastWeek}} - {{fridayLastWeek}}",
  "Period: {{dateFrom}} - {{dateTo}}": "Period: {{dateFrom}} - {{dateTo}}",
  "Scope: {{ totalCompleted }} owners analyzed (out of {{ total }})":
    "<0>Scope:</0> {{ totalCompleted }} owners analyzed (out of {{ total }})",
  "General efficiency": "General efficiency",
  "Daily average": "Daily average",
  "Indicates the overall efficiency of cash flow management during the analyzed week.":
    "Indicates the overall efficiency of cash flow management during the analyzed week.",
  "Liquidity indicator": "Liquidity indicator",
  "Provides information on the ability to meet short-term financial obligations and manage cash flow effectively. It calculates the daily average of the comparison between the total credits and investment withdrawals with the total debits of each day.":
    "Provides information on the ability to meet short-term financial obligations and manage cash flow effectively. It calculates the daily average of the comparison between the total credits and investment withdrawals with the total debits of each day.",
  "Profit opportunity": "Profit opportunity",
  "Additional liquid": "Additional liquid",
  "It represents the opportunity to generate additional financial income as a result of the cash flow optimization opportunities detected by the Smart Cash Pilot.":
    "It represents the opportunity to generate additional financial income as a result of the cash flow optimization opportunities detected by the Smart Cash Pilot.",
  "Efficiency Planning": "Efficiency Planning",
  "This section presents the cash management for the analyzed week and compares it with the results of the Smart Cash Pilot management.":
    "This section presents the cash management for the analyzed week and compares it with the results of the Smart Cash Pilot management.",
  "Model Optimization": "Model Optimization",
  "Improvement opportunities": "Improvement opportunities",
  "Additional Gain Opportunities": "Additional Gain Opportunities",
  "Minimum Cash Analysis": "Minimum Cash Analysis",
  "Ok, continue": "Ok, continue",
  "Categorize": "Categorize",
  "Massive categorization": "Massive categorization",
  "Transactions successfully saved!": "Transactions successfully saved!",
  "Pix successfully saved!": "Pix successfully saved!",
  "Payments successfully saved!": "Payments successfully saved!",
  "Hello, {{name}}": "Hello, {{name}}",
  "Cash management": "Cash management",
  "Banking institutions": "Banking institutions",
  "{{name}}, what is your area and function in the company?":
    "{{name}}, what is your area and function in the company?",
  "Invitation sent": "Invitation sent",
  "Area of action": "Area of action",
  "Function / Position": "Function / Position",
  "Financial": "Financial",
  "Treasury": "Treasury",
  "Accounts payable": "Accounts payable",
  "Accounts receivable": "Accounts receivable",
  "Accounting": "Accounting",
  "FP&A": "FP&A",
  "Analyst": "Analyst",
  "Coordinator": "Coordinator",
  "Manager": "Manager",
  "Director": "Director",
  "Specialist": "Specialist",
  "Process": "Process",
  "Cash opening": "Cash opening",
  "Cash closing": "Cash closing",
  "Cash analysis frequency": "Cash analysis frequency",
  "Policies": "Policies",
  "Liquidity": "Liquidity",
  "Products": "Products",
  "Choose the day of the week": "Choose the day of the week",
  "DDA": "Direito de Arena",
  "Analytical summary of the week: {{mondayLastWeek}} - {{fridayLastWeek}}":
    "<0>Analytical summary of the week:</0> {{mondayLastWeek}} - {{fridayLastWeek}}",
  "Analytical Summary": "Analytical Summary",
  "Position Investments": "Position Investments",
  "Financial movement": "Financial movement",
  "You had {{count}} accounts with negative balance":
    "You had <2>{{count}}</2> accounts with negative balance",
  "Expected interest *": "Expected interest *",
  "Oldest application date": "Oldest application date",
  "Incompleted sync": "Incompleted sync",
  "label.investmentsAppByMonthCustom": "Executive Report",
  "Account from": "From",
  "Account to": "To",
  "Day and hour": "Day and hour",
  "Created by": "Created by",
  "Transfer created successfully!": "Transfer created successfully!",
  "New transfer": "New transfer",
  "Search account": "Search account",
  "Ok, close": "Ok, close",
  "Transfers": "Transfers",
  "TRANSFER_FAILED": "Failed",
  "TRANSFER_REJECTED": "Rejected",
  "TRANSFER_REQUESTED": "Requested",
  "TRANSFER_CONFIRMED": "Completed",
  "TRANSFER_PENDING": "Pending",
  "TRANSFER_AWAITING_APPROVAL": "Awaiting approval",
  "TRANSFER_APPROVED": "Approved",
  "TRANSFER_REPROVED": "Reproved",
  "TRANSFER_REQUESTED_WITH_ERROR": "With error",
  "TRANSFER_PENDING_CONFIRMATION": "Pending confirmation",
  "Transfer's detail": "Transfer's detail",
  "Pix created successfully": "Pix created successfully",
  "Pix may take a few minutes to complete. Follow the status in the table below.":
    "Pix may take a few minutes to complete. Follow the status in the table below.",
  "Confirm your pix transfer": "Confirm your pix transfer",
  "BLOCKED_JUDICIAL": "Judicial blocked balance",
  "Registration status": "Registration status",
  "label.dailyBalancesByOwner": "Daily balances (by owners)",
  "Pix key": "Pix key",
  "key": "key",
  "key type": "key type",
  "RANDOM": "Random",
  "PHONE": "Phone",
  "Calculates the average of the daily ratio that compares the total credits/withdrawals with the total debits/investments.":
    "Calculates the average of the daily ratio that compares the total credits/withdrawals with the total debits/investments.",
  "30-day projection": "30-day projection",
  "Investment order submitted": "Investment order submitted",
  "The invested amount will be blocked until the process finishes.":
    "The invested amount will be blocked until the process finishes.",
  "In Analysis": "In Analysis",
  "New investment": "New investment",
  "Confirm your investment": "Confirm your investment",
  "Inlcude attachments": "Inlcude attachments",
  "Money movement": "Money movement",
  "Transfer": "Transfer",
  "Invest / Withdraw": "Invest / Withdraw",
  "Manual transactions": "Manual transactions",
  "Manual transactions (Upload file)": "Manual transactions (Upload file)",
  "Manual positions": "Manual positions",
  "Automatic application (balance)": "Automatic application (balance)",
  "Automatic application": "Automatic application",
  "Committed (net value)": "Committed (net value)",
  "CDBs (net value)": "CDBs (net value)",
  "Funds (net value)": "Funds (net value)",
  "Funds": "Funds",
  "Total applied": "Total applied",
  "Values successfully saved!": "Values successfully saved!",
  "Check the details of your investments or make a withdrawal quickly and easily.":
    "Check the details of your investments or make a withdrawal quickly and easily.",
  "Investment history": "Investment history",
  "New withdraw": "New withdraw",
  "Net value available": "Net value available",
  "Destination account": "Destination account",
  "Rescue details": "Rescue details",
  "Withdrawal amount": "Withdrawal amount",
  "Confirm your withdraw": "Confirm your withdraw",
  "Successful rescue order": "Successful rescue order",
  "FIXED_INCOME": "Fixed income",
  "Last Sync Time": "Last Sync",
  "No previous updates": "No previous updates",
  "Investments - deposit": "Investments - deposit",
  "Investments - committed": "Investments - committed",
  "Investments - fund": "Investments - fund",
  "See totals": "See totals",
  "Click on bar to see details": "Click on bar to see details",
  "subCategory": "Sub category",
  "Sub category": "Sub category",
  "Which banks are included?": "Which banks are included?",
  "Check out the table of available banks and extracts":
    "Check out the table of available banks and extracts",
  "Checking account": "Checking account",
  "Transaction Categories Fees Per Month":
    "Transaction Categories Fees Per Month",
  "Projected annual": "Projected annual",
  "Annual goal": "Annual goal",
  "Cashflow manual entries": "Cashflow manual entries",
  "Discard all changes": "Discard all changes",
  "Discard changes": "Discard changes",
  "Cashflow manual entries successfully saved!":
    "Cashflow manual entries successfully saved!",
  "Subcategory Type": "Subcategory Type",
  "Fixed Income Details": "Fixed Income Details",
  "All year": "All year",
  "Print": "Print",
  "Working capital": "Working capital",
  "Analysis by Institution": "Analysis by Institution",
  "Additional information": "Additional information",
  "Average compensation CDI": "Average compensation CDI",
  "Balance + Automatic Applications": "Balance + Automatic Applications",
  "label.monthlyAnalyticalOverview": "Analytical Overview - Photo of the Month",
  "Enter your details to login.": "Enter your details to login.",
  "Please enter a valid email address": "Please enter a valid email address",
  "Create a new password": "Create a new password",
  "Set up a secure password to protect your account.":
    "Set up a secure password to protect your account.",
  "Enter your details to active.": "Enter your details to active.",
  "Accept the use": "Accept the use",
  "Please enter a valid phone number": "Please enter a valid phone number",
  "Example": "Example",
  "Area activity": "Area activity",
  "label.balancesModel": "Balances Model",
  "Customer Reference": "Customer Reference",
  "Overdraft limit check": "Overdraft limit check",
  "label.investmentsDailyPosition": "Investments Daily Position",
  "label.dailyBalancesWithChart": "Daily balances with chart",
  "label.monthlyInvestmentPerformance": "Monthly Investment Performance",
  "All applied rules reflect data from the last 7 days.":
    "All applied rules reflect data from the last 7 days.",
  "Debts": "Debts",
  "IOF Exempt Balance": "IOF Exempt Balance",
  "Please review and accept to continue using our services.":
    "Please review and accept to continue using our services.",
  "User activated succefully!": "User activated succefully!",
  "Terms and Conditions accepted succefully!":
    "Terms and Conditions accepted succefully!",
  "label.dailyInvestmentPerformance": "Daily investment profitability",
  "Browse between categories": "Browse between categories",
  "Follow your company's all financial position":
    "Follow your company's all financial position",
  "Follow the status of all your bank connections":
    "Follow the status of all your bank connections",
  "Clear and up-to-date view of cash positions for strategic financial management":
    "Clear and up-to-date view of cash positions for strategic financial management",
  "Follow your portfolio": "Follow your portfolio",
  "Follow your financial transactions": "Follow your financial transactions",
  "Search client": "Search client",
  "Copy ID": "Copy ID",
  "Loading information": "Cargando informaciones",
  "View investments": "View investments",
  "View cash pilot": "View cash pilot",
  "Initiation type": "Initiation type",
  "label.pixTransactions": "Pix",
  "label.paymentsAndPixTransactions": "Payments and Pix",
  "Regenerate Transaction Summary": "Regenerate Transaction Summary",
  "First quarter": "First quarter",
  "Second quarter": "Second quarter",
  "Third quarter": "Third quarter",
  "Fourth quarter": "Fourth quarter",
  "Quarter": "Quarter",
  "label.quarter01": "Cash optimization",
  "label.quarter02": "Bank concentration",
  "label.quarter03": "Cash movement",
  "label.datanomik": "Datanomik",
  "My extracts": "My extracts",
  "Extract status": "Extract status",
  "Formats": "Formats",
  "New extract": "New extract",
  "Custom extracts may take up to 24 hours to process.":
    "Custom extracts may take up to 24 hours to process.",
  "Add a description": "Add a description",
  "Choose a link": "Choose a link",
  "Status of available extracts": "Status of available extracts",
  "Status of available downloads": "Status of available downloads",
  "Extracts": "Extracts",
  "Download available": "Download available",
  "Last 7 Days": "Last 7 Days",
  "Last 30 Days": "Last 30 Days",
  "Current Month": "Current Month",
  "Prev Month": "Prev Month",
  "The initial date is required": "The initial date is required",
  "The final date is required": "The final date is required",
  "Download completed successfully!": "Download completed successfully!",
  "Period statement execution created succefully!":
    "Period statement execution created succefully!",
  "label.periodStatementExecutions": "Period statement executions",
  "Period statement executions": "Period statement executions",
  "Payment": "Payment",
  "Edit payment categories": "Edit payment categories",
  "Edit pix categories": "Edit pix categories",
  "Overdraft": "Overdraft",
  "Recategorize Transactions": "Recategorize Transactions",
  "Categorization types": "Categorization types",
  "In progress extracts": "In progress extracts:",
  "Failed extracts": "Failed extracts:",
  "Completed extracts": "Completed extracts:",
  "In progress statement process": "In progress statement process:",
  "Pending statement process": "Pending statement process:",
  "Completed statement process": "Completed statement process:",
  "Executions": "Executions",
  "Download status": "Download status",
  "My reports": "My reports",
  "CUSTOM": "Custom",
  "Types of investments": "Types of investments",
  "Check out all types of investments in your portfolio":
    "Check out all types of investments in your portfolio",
  "Gross profitability": "Gross profitability",
  "Details": "Details",
  "Total balance": "Total balance",
  "Close to maturity": "Close to maturity",
  "Distribution by liquidity": "Distribution by liquidity",
  "Investments by institutions": "Investments by institutions",
  "Evolution of total investment": "Evolution of total investment",
  "Day": "Day",
  "Week": "Week",
  "Total investment": "Total investment",
  "Gross profit.": "Gross profit.",
  "Net profit.": "Net profit.",
  "Performance CDI": "Performance CDI",
  "Gross accumulated profitability": "Gross accumulated profitability",
  "Month movements": "Month movements",
  "movementInflow": "Inflow",
  "movementOutflow": "Outflow",
  "Commercial dollar": "Commercial dollar",
  "Clone view": "Clone view",
  "Fixed income investment": "Fixed income investment",
  "Committed investment": "Committed investment",
  "Fund investment": "Fund investment",
  "COE investment": "COE investment",
  "Gross yield": "Gross yield",
  "Total Last month": "Previous month's total",
  "Accumulated": "Current month's total",
  "CDBs deadlines": "CDBs deadlines",
  "Committed deadlines": "Committed deadlines",
  "Diversification of fixed income": "Diversification of fixed income",
  "Diversification of committed": "Diversification of committed",
  "Diversification of investment funds": "Diversification of investment funds",
  "Total gross expiration": "Total gross expiration",
  "Types present in the wallet": "Types present in the wallet",
  "Generate Monthly": "Generate Monthly Statements",
  "Committed days": "Committed days",
  "Unsaved changes": "Unsaved changes",
  "You have unsaved changes. Do you want to save them before closing?":
    "You have unsaved changes. Do you want to save them before closing?",
  "Position of applications": "Position of applications",
  "Application": "Application",
  "Allocation": "Allocation",
  "Purchase date": "Purchase date",
  "Purchase": "Purchase",
  "Maturity": "Maturity",
  "# note": "# note",
  "Purchase rate": "Purchase rate",
  "All institutions": "All institutions",
  "All owners": "All owners",
  "Net amount": "Net amount",
  "Total net ": "Total net",
  "Set the minimum CDI percentage expected by type of investment and the ideal maximum deadline for committed.":
    "Set the minimum CDI percentage expected by type of investment and the ideal maximum deadline for committed.",
  "Maximum period in Committed": "Maximum period in Committed",
  "applied days": "applied days",
  "Applications CDB": "Applications CDB",
  "Applications Committed": "Applications Committed",
  "Applications Funds": "Applications Funds",
  "Applications COE": "Applications COE",
  "Application details": "Application details",
  "Over {{days}} days applied": "Over {{days}} days applied",
  "CDI is below {{cdi}}%": "CDI is below {{cdi}}%",
  "Set minimum and/or maximum cash limits for the selected accounts":
    "Set minimum and/or maximum cash limits for the selected accounts",
  "No application with maturity for today.":
    "Nenhuma aplicação com vencimento para hoje.",
  "No application with maturity.": "Nenhuma aplicação com vencimento.",
  "Next maturity": "Next maturity",
  "{{total}} applications": "{{total}} applications",
  "1 application": "1 application",
  "No application with low performance": "No application with low performance",
  "Learn more in settings": "Learn more in settings",
  "Payment controller": "Payment controller",
  "PAYMENT_CONTROLLER": "Payment controller",
  "XP_OF": "XP",
  "CAIXA": "Caixa",
  "BRADESCO_OF": "Bradesco",
  "ITAU_OF": "Itaú",
  "SANTANDER_OF": "Santander",
  "BV_OF": "BV",
  "BTG_PACTUAL_CORP": "BTG",
  "CAIXA_READONLY": "Caixa",
  "UNICRED_OF": "Unicred",
  "BANCO_BRASIL_OF": "Banco do Brasil",
  "NORDESTE": "Nordeste",
  "SOFISA": "Sofisa",
  "STARK_BANK": "Stark Bank",
  "AGORA_OF": "Agora",
  "BTG_EMPRESAS_OF": "BTG",
  "SICREDI": "Sicredi",
  "AGORAINVESTIMENTOS": "Agora Investimentos",
  "XP": "XP",
  "SOFISA_OF": "Sofisa",
  "SAFRA": "Safra",
  "ITAU_WEB": "Itaú",
  "BANRISUL": "Banrisul",
  "ABC": "ABC",
  "BANCO_RENDIMENTO_OF": "Banco Rendimento",
  "C6_OF": "C6",
  "PINE": "Pine",
  "BTG_INVESTMENT_OF": "BTG",
  "CAIXA_OF": "Caixa",
  "SICOOB": "Sicoob",
  "SANTANDER": "Santander",
  "BRADESCO": "Bradesco",
  "label.allInstrumentMovements": "Investment Movement - All Instruments",
  "Some of the selected payments are older than 3 months and will not be requested.":
    "Some of the selected payments are older than 3 months and will not be requested.",
  "Owners and Accounts": "Owners and Accounts",
  "You are in the default view. Deleting this category here will permanently remove it from the entire system, including all other views.":
    "You are in the default view. Deleting this category here will permanently remove it from the entire system, including all other views.",
  "Type the name of the category to confirm deletion:":
    "Type the name of the category to confirm deletion:",
  "label.investmentsPortfolio": "Investments Portfolio",
  "Investments Portfolio.": "Investments Portfolio.",
  "Statement format": "Statement format",
  "Choose statement format": "Choose statement format",
  "Only PDF": "Only PDF",
  "Only OFX": "Only OFX",
  "Only XLS": "Only XLS",
  "PDF and OFX": "PDF and OFX",
  "Conciliator ID": "Conciliator ID",
  "Datetime": "Datetime",
  "Total investment performance": "Total investment performance",
  "Monthly performance comparison": "Monthly performance comparison",
  "Liquid profitability": "Liquid profitability",
  "CDI average": "CDI average",
  "IOF incident": "IOF incident",
  "IR average": "IR average",
  "IOF average": "IOF average",
  "Rescue index": "Rescue index",
  "Asset performance": "Asset performance",
  "Days average": "Days average",
  "Support": "Support",
  "Your Manager": "Your Manager",
  "General Support": "General Support",
  "Report a problem": "Report a problem",
  "Open a ticket for the technical team":
    "Open a ticket for the technical team",
  "Report.action": "Report",
  "Documentation": "Documentation",
  "Check out how to integrate our APIs": "Check out how to integrate our APIs",
  "Open": "Open",
  "Suggestions & Improvements": "Suggestions & Improvements",
  "Send us your idea": "Send us your idea",
  "Suggest": "Suggest",
  "We want to hear from you": "We want to hear from you",
  "ZenDesk": "ZenDesk",
  "Create and manage your tickets": "Create and manage your tickets",
  "Talk to support": "Talk to support",
  "Open in Web": "Open in Web",
  "Support Hours": "Support Hours",
  "Monday to Friday from 9am to 6pm.": "Monday to Friday from 9am to 6pm.",
  "Scan the QR Code with your phone": "Scan the QR Code with your phone",
  "Describe your idea": "Describe your idea",
  "Type your suggestion here...": "Type your suggestion here...",
  "This field is required": "This field is required",
  "The suggestion must be at least 10 characters long":
    "The suggestion must be at least 10 characters long",
  "Send": "Send",
  "label.dailyConciliation": "Daily conciliation",
  "Thank you for your suggestion!": "Thank you for your suggestion!",
  "Your feedback helps us improve our service.":
    "Your feedback helps us improve our service.",
  "ITAU_BBA": "Itaú BBA",
  "MERCURY": "Mercury",
  "JEEVES": "Jeeves",
  "BREX": "Brex",
  "SVB": "Silicon Valley",
  "MORGAN_STANLEY": "Morgan Stanley",
  "SILICON_VALLEY": "Silicon Valley",
  "Validating login to {{institution}}": "Validating login to {{institution}}",
  "See less": "See less",
  "more": "more",
  "Projected percentage": "Projected percentage",
  "label.dailyCashStatement": "Daily cash statement",
  "label.accountsBalanceErp": "Accounts balance - ERP",
  "Profitability and gain month by month":
    "Profitability and gain month by month",
  "Monthly asset evolution": "Monthly asset evolution",
  "Average annual CDI Performance": "Performance média anual CDI",
  "Annual profitability": "Annual profitability",
  "Investment comparator": "Investment comparator",
  "Deadline for rescue": "Deadline for rescue",
  "Enter a value": "Enter a value",
  "Use idle balance": "Use idle balance",
  "Investment Performance Analysis": "Investment Performance Analysis",
  "DI return": "DI return",
  "Due date": "Due date",
  "Equilibrium": "Equilibrium",
  "Follow all about your investments": "Follow all about your investments",
  "Bank Credentials": "Bank Credentials",
  "Your credentials are encrypted and stored securely.":
    "Your credentials are encrypted and stored securely.",
  "Secure integration with your bank.": "Secure integration with your bank.",
  "To automate your transactions and connect your bank account to the platform, please enter the credentials provided by your bank.":
    "To automate your transactions and connect your bank account to the platform, please enter the credentials provided by your bank.",
  "New Credential": "New Credential",
  "Connect your bank credentials securely.":
    "Connect your bank credentials securely.",
  "To carry out transactions automatically, we need you to enter the credentials provided by your bank. This information is used only to integrate your bank account and is not exposed at any time.":
    "To carry out transactions automatically, we need you to enter the credentials provided by your bank. This information is used only to integrate your bank account and is not exposed at any time.",
  "No credentials registered for this bank":
    "No credentials registered for this bank",
  "1 credential registered for this bank":
    "<b>1 credential</b> registered for this bank",
  "{{count}} credentials registered for this bank":
    "<b>{{count}} credentials</b> registered for this bank",
  "Public Certificate": "Public Certificate",
  "Private Certificate": "Private Certificate",
  "Client Secret": "Client Secret",
  "Client ID": "Client ID",
  "Api Key": "Api Key",
  "Create Credential": "Create Credential",
  "Could not validate the data. Please confirm and try again.":
    "Could not validate the data. Please confirm and try again.",
  "Change": "Change",
  "Certificate": "Certificate",
  "Integrations": "Integrations",
  "Certificates": "Certificates",
  "Certificate found": "Certificate found",
  "A1 Certificate": "A1 Certificate",
  "Replace Certificate": "Replace Certificate",
  "label.financialEfficiency": "Financial Efficiency",
  "Institution Client Id": "Client ID",
  "Choose an institution": "Choose an institution",
  "Remuneration Account": "Remuneration Account",
  "label.applicationHistory": "Application History",
  "Rejection reason": "Rejection reason",
  "Barcode": "Barcode",
  "Change to view mode": "Change to view mode",
  "Change to edit mode": "Change to edit mode",
  "Cashflow projected successfully saved!":
    "Cashflow projected successfully saved!",
  "Manual cash flow (Upload file)": "Manual cash flow (Upload file)",
  "label.futureTransactions": "Future transactions",
  "Edit purchase rate": "Edit purchase rate",
  "Purchase rate updated successfully": "Purchase rate updated successfully",
  "Go to Datanomik Treasury": "Go to Datanomik Treasury",
  "View transfer rules": "View transfer rules",
  "Transfer rules for remuneration account":
    "Transfer rules for remuneration account",
  "Rule": "Rule",
  "Amount to transfer": "Amount to transfer",
  "Fixed amount": "Fixed amount",
  "Above amount": "Above amount {{amount}}",
  "Excess amount": "Excess amount",
  "Accounts without statement": "Accounts without statement",
  "Without statement detail": "Without statement detail",
  "With receipt": "With receipt",
  "1 receipt requested": "1 receipt requested",
  "{{count}} receipts requested": "{{count}} receipts requested",
  "Showing requested receipts": "Showing requested receipts",
  "label.paymentSlips": "Payment slips",
  "Payment slips by account.": "Payment slips by account.",
  "Sync account payment slips: {{totalPaymentSlipProcessed}}/{{total}}":
    "Payment slips: {{totalPaymentSlipProcessed}} of {{total}} accounts",
  "Payment slip": "Payment slip",
  "PAYMENT_SLIP": "Payment slip",
  "Select or drop PFX file": "Select or drop PFX file",
  "PFX Password": "PFX Password",
  "Validate": "Validate",
  "Invalid PFX file": "Invalid PFX file",
  "Invalid password": "Invalid password",
  "Download all filtered payment receipts":
    "Download all filtered payment receipts",
  "Request all filtered payment receipts":
    "Request all filtered payment receipts",
  "Cannot download more than 1000 payments receipts.":
    "Cannot download more than 1000 payments receipts.",
  "NEXT_DAY": "Next day",
  "NEXT_WEEK": "Next week",
  "NEXT_15_DAYS": "Next 15 days",
  "NEXT_30_DAYS": "Next 30 days",
  "NEXT_MONTH": "Next month",
  "DERIVATIVE": "Derivative",
  "Derivative investment": "Derivative investment",
  "BANK_OF_CHINA": "Bank of China",
  "label.bankTransfersErp": "Application movements",
  "Our number": "Our number",
  "Your number": "Your number",
  "Payer": "Payer",
  "Charged amount": "Charged amount",
  "Fluctuation": "Fluctuation",
  "Occurrence": "Occurrence",
  "Invalid MFA code": "Invalid MFA code",
  "Realized": "Realized",
  "Categories breakdown": "Categories breakdown",
  "Projected balance": "Projected balance",
  "vs projected": "vs projected",
  "No data available for this date": "No data available for this date",
  "Click on a bar to see category breakdown":
    "Click on a bar to see category breakdown",
  "No data available": "No data available",
  "Press ESC to exit": "Press ESC to exit",
  "Realized Inflows": "Realized Inflows",
  "Projected Inflows": "Projected Inflows",
  "Realized Outflows": "Realized Outflows",
  "Projected Outflows": "Projected Outflows",
  "Net Cash Flow": "Net Cash Flow",
  "Sections breakdown": "Sections breakdown",
  "Click on a section to see its categories":
    "Click on a section to see its categories",
  "label.unifiedInflowTransactions": "Unified Inflow Transactions",
  "label.cashPoolingAccounts": "Cash Pooling Accounts",
  "Cash pooling account balances.":
    "Account balances for cash flow with remunerated account projection",
  "Transfer Client Id": "Transfer Client Id",
  "Transfer Secret": "Transfer Secret",
  "Pix Transfer Client Id": "Pix Transfer Client Id",
  "Pix Transfer Secret": "Pix Transfer Secret",
  "Client Id": "Client Id",
  "label.financialPlanning": "Financial planning",
};
